import { ProcedureTrackerActivityDataService } from './../../../data-services/procedure-tracker-activity/procedure-tracker-activity.data.service';
import { ProcedureTrackerActivity } from './../../../classes/activity/procedure-tracker.activity.class';
import { EventsToolService } from '@omni/services/events-tool/events-tool.service';
import {
  takeUntil,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
  map,
  filter,
  withLatestFrom,
  shareReplay,
  startWith,
} from 'rxjs/operators';
import { ReportService } from './../../../services/reports/report.service';
import { EventsService } from './../../../services/events/events.service';
import { Component, ViewChild, ElementRef, Output, EventEmitter, AfterViewInit, NgZone, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { ActivityDataService } from '../../../data-services/activity/activity.service';
import { ActivityService } from '../../../services/activity/activity.service';
import {
  Activity,
  ActivityType,
  ActivityTypeToFilterNameMap,
  MeetingActivityState,
  PhoneCallActivityState
} from '../../../classes/activity/activity.class';
import { NavController, PopoverController, ModalController, LoadingController } from '@ionic/angular';
import {
  format,
  isToday,
  isTomorrow,
  isValid,
  differenceInCalendarDays,
  addMinutes,
  isSameDay
} from "date-fns";
import { FooterService, FooterViews } from '../../../services/footer/footer.service';
import { LogService } from '../../../services/logging/log-service';
import { UIService } from '../../../services/ui/ui.service';
import { DeviceService } from '../../../services/device/device.service';
import { MeetingDataService, InitiateMeetingPayload, UpdateMeetingPayload } from '../../../data-services/meeting/meeting.data.service';
import { MeetingLocationCaptureService } from '../../../data-services/meeting/meeting-location-capture.service';
import { AppointmentActivity, CovisitorAccess } from '../../../classes/activity/appointment.activity.class';
import { WebsocketDataService } from '../../../data-services/websocket/websocket.data.service';
import { ContactOfflineService } from '../../../services/contact/contact.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { TrackService, TrackingEventNames } from '../../../services/logging/tracking.service';
import { AccountOfflineService } from '../../../services/account/account.offline.service';
import { NavigationService, PageName, ChildNavNames } from '../../../services/navigation/navigation.service';
import { 
  BehaviorSubject,
  combineLatest,
  merge,
  Observable,
  Subject
} from 'rxjs';
import { RepServices } from '../../../data-services/rep/rep.services';
import { DurationType, TimeOffActivity } from "../../../classes/activity/timeoff.class";
import { TimeOffService } from "../../../services/time-off/time-off.service";
import { SampleDataService } from '../../../data-services/sample/sample.data.service';
import { SampleActivity } from '../../../classes/activity/sample.activity.class';
import { SampleService } from '../../../services/sample/sample.service';
import { FeatureActionsMap, IoConfigurationFeatureCodes } from '../../../classes/authentication/user.class';
import { SchedulerService } from '../../../services/scheduler/scheduler.service';
import { ActivitiesFilterPopoverComponent } from '../../activities-filter-popover/activities-filter-popover';
import { EmailActivity, EmailActivityParty, EmailActionType, EmailAddress } from '../../../classes/activity/email.activity.class';
import { EmailService } from '../../../services/email-templates/email.service';
import { DeltaService } from '../../../data-services/delta/delta.service';
import { FollowUpActivityDataService } from '../../../data-services/follow-up-activity/follow-up-activity.data.service';
import { FollowUpActivity, FOLLOW_UP_TYPE } from '../../../classes/activity/follow-up-action.activity.class';
import { TranslateService } from '@ngx-translate/core';
import { OrderActivity } from '../../../classes/activity/order.activity.class';
import { CaseManagementService } from '../../../services/case-management/case-management.service';
import { CaseActivity } from '../../../classes/case-intake/case-activity.class';
import { OrderActivityDataService, OperationDetail } from '../../../data-services/order-activity/order-activity.data.service';
import {GlobalUtilityService} from "../../../services/global-utility.service";
import { MainCardViewDataModel } from '../../../models/MainCardViewDataModel';
import { AlertService } from '../../../services/alert/alert.service';
import { NotificationService, ToastStyle } from '../../../services/notification/notification.service';
import { IpcEventListner } from '../../../services/electron-api';
import {Utility} from "../../../utility/util";
import { PhoneActivity, OFFLINE_PHONE_CALL_ID_PREFIX } from '../../../classes/activity/phone.activity.class';
import { PhoneCallDataService, InitiatePhoneCallPayload } from '../../../data-services/phone-call/phonecall.data.service';
import { DateTimeFormatsService } from '@omni/services/date-time-formats/date-time-formats.service';
import { AgendaFooterView, AgendaFooterService } from '@omni/services/footer/agenda-footer.service';
import { Channel, ChannelType, ChannelActivityType } from '@omni/classes/consent/channel.class';
import { ConsentService } from '@omni/services/consent/consent.service';
import { ResourceEmailTemplate } from '@omni/classes/email-templates/email-template.class';
import { SurgeryOrderActivity } from '@omni/classes/activity/surgery-order.activity.class';
import { SurgeryOrderActivityDataService } from '@omni/data-services/surgery-order-activity/surgery-order-activity.data.service';
import { DatePipe } from '@angular/common';
import { TimeOffDataService } from '@omni/data-services/time-off/time-off.data.service';
import { DB_KEY_PREFIXES } from '@omni/config/pouch-db.config';
import { IndDropdownListDetailModel } from '@omni/models/indDropdownListModel';
import { IndDropdownListComponent } from '@omni/components/shared/ind-dropdown-list/ind-dropdown-list';
import { ResourceService } from '@omni/services/resource/resource.service';
import { PresentationService } from '@omni/services/presentation/presentation.service';
import { DiskService } from '@omni/services/disk/disk.service';
import { BrandOfflineService } from '@omni/services/brand/brand.service';
import { Presentation } from '@omni/classes/presentation/presentation.class';
import { FeatureProfiler, ProfilerInstance } from '@omni/services/logging/feature-profiler.service';
import { Resource } from '@omni/classes/resource/resource.class';
import { OpportunityManagementService } from '@omni/services/opportunity-management/opportunity-management.service';
import { AccountManagementOfflineService } from '@omni/services/account-management/account-management.service';
import { OrderManagementService } from '@omni/services/order-management/order-management.service';
import { MyAssistantService } from '@omni/services/my-assistant/my-assistant.service';
import { EntityNameForTranslation, LocalizationService } from '@omni/services/localization/localization.service';
import { startRecursiveActivityScheduleConflictFlagging, startRecursiveEventScheduleConflictFlagging, startRecursiveActivityCloseByActivityFlagging } from '../../../utility/activity.utility';
import { IndFilterMenuComponent } from '@omni/components/shared/ind-filter-menu/ind-filter-menu';
import { ContactsModel } from '@omni/classes/contact/contact.class';
import { StoreCheckActivity } from '@omni/classes/activity/store-check.activity.class';
import { SetBookingDataService } from '@omni/data-services/set-booking/set-booking.data.service';
import { FeatureActionsService } from '@omni/services/feature-actions/feature-actions.service';
import { SetBookingActivity, SetBookingStatus } from '@omni/classes/activity/set-booking.activity.class';
import { MedicalInquiry } from '@omni/classes/medical-inquiry/medical-inquiry.class';
import { MedicalInquiryDataService } from '@omni/data-services/medical-inquiry/medical-inquiry.data.service';
import { MedicalInquiryService } from '@omni/services/medical-inquiry/medical-inquiry.service';
import { MedicalInquiryDetailComponent } from '@omni/components/medical-inquiry/medical-inquiry-detail/medical-inquiry-detail.component';
import { DynamicFormsService } from '@omni/services/dynamic-forms/dynamic-forms-service';
import { MobileAppTemplateType } from '@omni/classes/survey/survey-form.class';
import { SurveyService } from '@omni/services/survey/survey.service';
import { Guid } from 'typescript-guid';
import { SecInfoConfigDataService } from '@omni/data-services/sec-info-config/sec-info-config-data-service';
import { SecondaryInfoEntityName } from '@omni/classes/sec-info-config/sec-info.class';
import { IONote } from '../../../classes/io/io-note.class';
import { SearchConfigService } from '@omni/services/search/search-config.service';
import { cloneDeep, isEmpty, isEqual, orderBy, sortedIndexBy } from 'lodash-es';
import { _ } from '@omni/utility/lodash-chain';
const NumberOfSkeletonCardsToDisplay = 12;

/**
 * Generated class for the ActivitiesPaneComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
// OnPush deferred — reads activityService, uiService, authService directly in template
@Component({
  selector: 'activities-pane',
  templateUrl: 'activities-pane.html',
  styleUrls:['activities-pane.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ActivitiesPaneComponent implements AfterViewInit {

  newTimeOff: TimeOffActivity = new TimeOffActivity({}, ActivityType.TimeOff);
  public isExpanded: boolean = false;
  public itemExpandHeight: number = 25;
  public myIcon = "chevron-down-outline";
  public activityType: string = 'All Activities';
  public activityTypes: string[];   //= ['All Activities', 'Appointment', 'Phone', 'Email'];
  public todaysActivity: Activity[];
  public lastActiveSegment: string = 'agenda';  // CWD-2422 Track the changes between segments view
  public istoday = (date: Date) => this.dateTimeFormatService.isTodayDate(date);
  sameDayFlag: boolean = false;
  scrollOnce: boolean;
  scrollDate: Date;
  selectedActivity: any;
  public groupedActivities$ = new BehaviorSubject<any[]>(null);
  private readonly scroll$ = new Subject<number>();
  public groupActvitiesDate: Date[] = [];
  public months: Array<String> = ["January", "Febuary", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];
  public weekDay: Array<String> = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

  public loadMoreText: string = 'Load more...';
  public trackPrevActivityLength: number = 0;
  public currentActivityLength: number = 0;

  public hasBaselineEnabled: boolean = false;
  public globalCustomerText: string;
  public dateDividers: Array<number>;
  private hasTimeoffEnabled: boolean = false;
  public isDeviceOnline: boolean = true;
  private _isSegmentChanged: boolean = false;
  private _isAgendaRefreshed: boolean = false;
  private _scrollToTodayAfterRefresh: boolean = false;
  private _lastAgendaSearchText = '';
  private _isRefreshInProgress: boolean = false;
  private _isFilteringInProgress: boolean = false;
  private _refreshStartTime: number = 0;
  private readonly PERFORMANCE_THRESHOLD = 1000; // 1 second threshold for slow operations
  private ngDestroy$ = new Subject<boolean>();
  public selectedTabValue: string = 'agenda';
  public numberOfSkeletonCardsToDisplay = NumberOfSkeletonCardsToDisplay;


  @ViewChild('expWrapper', {static:true}) expandWrapper: ElementRef;
  @ViewChild('content', {static:true}) content: HTMLIonContentElement;

  @Output() onAddNewActivityClick = new EventEmitter();
  @Output() scheduleSelected = new EventEmitter<any>(null);
  private scrolledDateChange$ = new Subject<Date>();
  @Output() scrolledDateChange = new EventEmitter<Date>();
  @Input() refreshSchedulerList: boolean = false;

  hasSamplingEnabled: boolean;
  hasEmailEnabled: boolean;
  hasCustomerInquiries: boolean
  hasPhoneCallEnabled: boolean  = false;
  private hasSuggestedMeetingsEnabled: boolean;
  private hasSuggestedTaskEnabled: boolean;
  private isFollowUpTasksVisible: boolean = false;
  private isOrderActivitiesEnabled: boolean = false;
  private isProcedureLogActivitiesEnabled: boolean = false;
  private isProcedureTrackerActivitiesEnabled: boolean = false;
  private isSetBookingActivitiesEnabled:boolean = false;
  private isMedicalInquiryEnabled:boolean = false;
  public template: ResourceEmailTemplate;

  private _scrollToInvokeCounter = 0;
  public confirmNewPattern:boolean = false;
  reportTilesSlideOpts= {
    initialSlide: 1,
    speed: 400
  }
  hasEdgeAnalyticsEnabled: boolean = false;
  public hasSchedulerEnabled: boolean = false;
  date_fns_locale: any;

  shouldShowSearchBarFilterButton: boolean = true;
  isAndroid: boolean = false;
  filterAtHome: string;
  filterValueAtHome: string;
  private copySurgeryOrderActivityInProgress:boolean = false;
  private copySetBookingActivityInProgress:boolean = false;
  private copyMedicalInquiryInProgress:boolean = false;
  public backgroundUploadInProgress: boolean = false;
  public syncInProgress: boolean = false;
  private hasAccountVisitEnabled = false;


  public localDbDataLoadInProgress = false;
  public syncMessage = this.translate.instant('UPLOAD_IN_PROGRESS');

  topPad = 0;
  private _prefix: number[] = [];
  visibleItems: any[] = [];
  private _viewdataCache: Map<string, any> = new Map();
  private currentScrollY: number = 0;
  totalHeight: number = 0;
  private startItemIndex: number;
  private visibleStartIndex = 0;
  private visibleEndIndex = 0;

  @Output() activityOpenedFromActivities = new EventEmitter<any>();

  constructor(
    private phonecallDataService: PhoneCallDataService,
    public activityDataService: ActivityDataService,
    public activityService: ActivityService,
    public navCtrl: NavController,
    public footerService: FooterService,
    public logServices: LogService,
    public device: DeviceService,
    public events: EventsService,
    private alertService: AlertService,
    private meetingService: MeetingDataService,
    private meetingLocationCaptureService: MeetingLocationCaptureService,
    public contactService: ContactOfflineService,
    private websocket: WebsocketDataService,
    public uiService: UIService,
    private _ngZone: NgZone,
    private _cd: ChangeDetectorRef,
    public authenticationOfflineService: AuthenticationService,
    private trackingService: TrackService,
    public accountOfflineService: AccountOfflineService,
    private navService: NavigationService,
    public repService: RepServices,
    public timeOffService: TimeOffService,
    public sampleDataService: SampleDataService,
    public sampleService: SampleService,
    private schedulerService: SchedulerService,
    public popoverCtrl: PopoverController,
    public emailService: EmailService,
    public deltaService: DeltaService,
    private followUpDataService: FollowUpActivityDataService,
    private caseManagementService: CaseManagementService,
    private orderActivityDataService: OrderActivityDataService,
    public translate : TranslateService,
    public utilityService:GlobalUtilityService,
    private notificationService: NotificationService,
    public reportService: ReportService,
    public modalCtrl: ModalController,
    private dateTimeFormatService: DateTimeFormatsService,
    public agendaFooterService: AgendaFooterService,
    private consentService: ConsentService,
    private surgeryOrderActivityDataService: SurgeryOrderActivityDataService,
    public datepipe: DatePipe,
    private timeOffDataService: TimeOffDataService,
    private followUpActivityDataService: FollowUpActivityDataService,
    private resourceService: ResourceService,
    private presentationService: PresentationService,
    private readonly diskService: DiskService,
    private brandService: BrandOfflineService,
    public opportunitiesService: OpportunityManagementService,
    private readonly accountManagementService: AccountManagementOfflineService,
    private orderManagementService: OrderManagementService,
    private eventsToolService: EventsToolService,
    private procedureTrackerActivityDataService: ProcedureTrackerActivityDataService,
    public assistantService: MyAssistantService,
    private localizationService: LocalizationService,
    private readonly setBookingDataService: SetBookingDataService,
    public faService: FeatureActionsService,
    private readonly dynamicFormService: DynamicFormsService,
    public readonly surveyService: SurveyService,
    private readonly searchConfigService: SearchConfigService,
    public secInfoConfigDataService: SecInfoConfigDataService,
    private loadingController: LoadingController,
    private readonly medicalInquiryDataService: MedicalInquiryDataService,
    private readonly medicalInquiryService: MedicalInquiryService,
    private readonly featureProfiler: FeatureProfiler
  ) {
    this.dateDividers = [];
    this.activityService.activityFilter = ActivityType.AllActivity;
    this.filterAtHome = this.activityService.activityFilter;
    this.filterValueAtHome = this.translate.instant('HOME');
    this.translate.onLangChange.subscribe(data =>{
      this.filterValueAtHome = this.translate.instant('HOME');
      this.date_fns_locale = this.localizationService.getDateFnsLocaleObject();
      this.refreshHeader();
      this.events.publish('AgendaRefreshDone');
    });


    this.scrolledDateChange$.pipe(
      distinctUntilChanged(),
      takeUntil(this.ngDestroy$)
    ).subscribe(date => {
      this.scrolledDateChange.emit(date);
    });

    this.events.unsubscribe('filterActivitiesDataForSelectedUser');
    this.events.subscribe('filterActivitiesDataForSelectedUser', async (data) => {
      let loader: HTMLIonLoadingElement = null;
      if (data === 'UserSelected') {
        loader = await this.loadingController.create();
        await loader.present();
        try {
          await this.activityDataService.fetchAgendaTeamViewActivities(this.authenticationOfflineService.impersonatedUser.userId);
          this.filterAgendaData(data);
          await this.navService.setChildNavRoot(PageName.NothingSelectedView,PageName.NothingSelectedView,PageName.GoAppActivitiesPageComponent);
        } catch (error) {
          this.onStopImpersonation();
        }
        // Team view mode enabled
        this.uiService.showNewActivity = false;
        data = null;
      }else if(data === 'MultipleOptionFilter' && this.activityService.multiOptionActivityFilter){
        if(this.activityService.multiOptionActivityFilter.some(a=> a.categoryPath == "Users" && a.value != this.authenticationOfflineService.user.systemUserID)){
            loader = await this.loadingController.create();
            await loader.present();
            this.activityService.selectedActivity = undefined;
            this.authenticationOfflineService.impersonatedUser = null;
            this.uiService.activeView = '';
            let userIds = _(this.activityService.multiOptionActivityFilter)
              .filter(b => b.categoryPath === 'Users' && b.value && b.value != this.authenticationOfflineService.user.systemUserID)
              .map(b => b.value as string)
              .value();
            const allUsers = this.authenticationOfflineService.user?.buSettings["indskr_homepageteamview"]===548910001
              ? [
                ...this.authenticationOfflineService.user.childUsers,
                ...this.authenticationOfflineService.user.siblingUsersCommonParent,
                ...this.authenticationOfflineService.user.siblingUsersCommonPositions
              ]
              : this.authenticationOfflineService.user.childUsers;
            this.authenticationOfflineService.impersonatedUser = allUsers?.find(a=> userIds.includes(a.userId));
            try {
              await this.activityDataService.fetchAgendaTeamViewActivities(userIds.join(','),true);
              this.filterAgendaData('MultipleOptionFilter');
              await this.navService.setChildNavRoot(PageName.NothingSelectedView,PageName.NothingSelectedView,PageName.GoAppActivitiesPageComponent);
            } catch (error) {
              this.onStopImpersonation();
            }
            // Team view mode enabled
            this.uiService.showNewActivity = false;
            data = null;
          }else{
            this.filterAgendaData('MultipleOptionFilter');
          }
      }else{
        this.filterAgendaData(data);
      }
      if (loader) {
        await loader.dismiss();
      }
    })


    this.events.observe('refreshAgenda')
    .pipe(
      takeUntil(this.ngDestroy$),
      debounceTime(250),
    ).subscribe((args) => {
      if (args === 'sync successful' || args === 'sync failed') {
        this.resetFeatureAction();
      }
      this.refreshAgenda();
      setTimeout(() => {
        this.refreshScroll();
      }, 100);
    });

    this.events.observe('scrollToDate').pipe(takeUntil(this.ngDestroy$)).subscribe(() => {
      this.refreshScroll(true);
    });

    this.events.observe('activity-pane:selectActivity').pipe(takeUntil(this.ngDestroy$)).subscribe((activity) => {
      this.openActivityDetails(activity);
    });
    this.events.observe('activity-pane:selectActivity-kitBookingSubmission').pipe(takeUntil(this.ngDestroy$)).subscribe((activity) => {
      this.openActivityDetails(activity, false, false, false);
    });

    this.events.observe('refreshAgendHeader').pipe(takeUntil(this.ngDestroy$)).subscribe(() => {
      this.refreshHeader();
      if (this.agendaFooterService.actSegment === 'agenda'){
        this.events.publish("updateCurrentDate");
        if (this.uiService.toolsActivityActive) {
          this.uiService.toolsActivityActive = false;
          this.refreshAgenda();
        }
      }
    })

    this.events.observe("start-websocket-subscription").pipe(
      takeUntil(this.ngDestroy$))
      .subscribe(() => {
        if (!this.device.isOffline && this.navService.getPreviousPageName() !== PageName.CoachingActivitiesComponent
          && this.navService.getCurrentPageName() !== PageName.CoachingActivitiesComponent) {
          if (this.activityService.selectedActivity instanceof AppointmentActivity) {
            (async () => this.websocket.removeSubscription(this.activityService.selectedActivity))();
            (async () => this.websocket.subscribeToMeetingTopic(this.activityService.selectedActivity))();
          }
        }
      });

     this.uiService.activeView = 'Appointment';
  }

  @IpcEventListner('open-url')
  private externalUrl(event, data) {
    let obj = Utility.getUrlParams(data['url']);
    if (this.authenticationOfflineService.user.xSystemUserID != obj['userId']) return;
    if (this.device.isOffline) return;
    if (this.uiService.activeView != "Appointment") {
      this.navService.popToRootWithPageTracking();
      this.uiService.activeView = "Appointment";
    }
    if (this.uiService.activeView == "Appointment") {
      this.navService.pushWithPageTracking(PageName.NewActivityComponent, PageName.NewActivityComponent);
      this.activityService.invokeCallCenterActivity$.next(true);
      this.activityService.contactCenterActivityInputs$.next(obj);
    }
  }

  public refreshAgenda() {
    const refreshAgendaNonce: number = new Date().getTime();
    this.activityService.refreshAgendaNonce = refreshAgendaNonce;
    this.activityService.refreshAgendaAction$.next({ action: 'Run', nonce: refreshAgendaNonce });
    this.caseManagementService.reMapDataWithValues(this.accountOfflineService.accounts, this.contactService.contacts);
    if (!this.activityService.teamViewActive) {
      this.activityTimeConflictCheck();
    }
    this.activityService.filterDisplayActivity();

    const skipRefreshList = [PageName.SurveyPageComponent,PageName.CustomerCallPlanPage,PageName.ContactPageComponent,PageName.AccountPageComponent];
    const currentMasterPageName = this.navService.getCurrentMasterPageName();
    if(!skipRefreshList.includes(currentMasterPageName)) {
      const searchText = this.activityService.activitiesSearchText ?? '';
      if (this._lastAgendaSearchText && !searchText) this._scrollToTodayAfterRefresh = true;
      this._lastAgendaSearchText = searchText;
      this.groupedActivities$.next(this.createAgendaArrayFromActivities());
      if (this._scrollToTodayAfterRefresh) {
        this._scrollToTodayAfterRefresh = false;
        this.scrollToDate(new Date());
      }
    }
    this._isAgendaRefreshed = true;
    this.events.publish('filterChanged', this.activityService.activityFilter);
    this.activityService.refreshAgendaAction$.next({ action: 'Stop', nonce: refreshAgendaNonce });
    this.activityService.refreshAgendaAction$.next({ action: 'Idle', nonce: null });
  }

  private activityTimeConflictCheck() {
    this.activityService.setConflictCheckState('Running');

    // Sort & reset
    this.activityService.sortAllActivitiesByStartDateTime(true);
    this.eventsToolService.clearConflictActivityIds();

    try {
      const userId: string = this.authenticationOfflineService.user.xSystemUserID;
      // Find starting Index
      const startIdx = this.activityService.findAndSetConflictCheckStartIdx();
      for (let i = startIdx; i < this.activityService.activities.length; i++) {
        const activity = this.activityService.activities[i];
        if (activity.type === ActivityType.Appointment) {
          startRecursiveActivityScheduleConflictFlagging(this.activityService.activities, i, userId, this.hasAccountVisitEnabled);
          startRecursiveEventScheduleConflictFlagging(this.eventsToolService.eventsToolData, activity, userId);
        } else if (activity.type === ActivityType.PhoneCall) {
          if (!this.hasPhoneCallEnabled) {
            continue;
          }
          startRecursiveActivityScheduleConflictFlagging(this.activityService.activities, i, userId, this.hasAccountVisitEnabled);
          startRecursiveEventScheduleConflictFlagging(this.eventsToolService.eventsToolData, activity, userId);
        } else if (activity.type === 'TimeOff' || activity.type === 'TimeOffRequest') {
          if (!this.hasTimeoffEnabled) {
            continue;
          }
          startRecursiveActivityScheduleConflictFlagging(this.activityService.activities, i, userId, this.hasAccountVisitEnabled);
          startRecursiveEventScheduleConflictFlagging(this.eventsToolService.eventsToolData, activity, userId);
        }
      }
      if (this.authenticationOfflineService.user.meetingProximityWarningPeriod > 0) {
        const myMeetingsWithContacts: Activity[] = this.activityService.activities.filter(activity => activity instanceof AppointmentActivity && (activity.meetingOwnerId === userId ||
          (Array.isArray(activity.accompaniedUserList) && activity.accompaniedUserList.findIndex(a => a.id === userId) >= 0)) && !isEmpty(activity.contacts));
        if (!isEmpty(myMeetingsWithContacts)) {
          for (let i = 0; i < myMeetingsWithContacts.length; i++) {
            startRecursiveActivityCloseByActivityFlagging(myMeetingsWithContacts, i, userId, this.authenticationOfflineService.user.meetingProximityWarningPeriod, this.hasAccountVisitEnabled);
          }
        }      }
    } catch (error) {
      console.error('activityTimeConflictCheck: ', error);
    }
    // Publish conflict check done.
    this.activityService.setConflictCheckState('Done');
  }
  
  public createAgendaArrayFromActivities(): Array<object> {

    const src = this.activityService.displayActivities;
    const searchText = this.activityService.activitiesSearchText;
    const hasSearchText = searchText && searchText.length >= 1;

    const noActivityForToday = hasSearchText ? [] : this._createNoActivityForTodayItems(new Date());
    if (src?.length === 0) {
      return [...noActivityForToday];
    }
    let returnedArray = [];
    const today = new Date();
    const todayKey = this._getLocalDateKey(today);
    let hasToday = false;

    const filteredActivities: Activity[] = [];
    const accountVisitNestedMeetingsMap: Map<string, Activity[]> = new Map();

    for (const activity of src) {
      if (!this.dateTimeFormatService.isValidDate(activity.scheduledStart)) {
        continue;
      }

      if (hasSearchText && !this.activityService._checkIfActivityIncludesSearchText(activity, searchText)) {
        continue;
      }

      if (activity.type === 'TimeOff' || activity.type === 'TimeOffRequest') {
        if (!this.hasTimeoffEnabled) continue;
      } else if (activity.type === ActivityType.Appointment && activity['indskr_suggest'] && !this.hasSuggestedMeetingsEnabled) {
        continue;
      } else if (!this.hasSamplingEnabled && activity.type === 'Sample') {
        continue;
      } else if (!this.hasCustomerInquiries && activity.type === ActivityType.CaseIntake) {
        continue;
      } else if (activity.type === ActivityType.PhoneCall && !this.hasPhoneCallEnabled) {
        continue;
      } else if (!this.hasEmailEnabled && activity.type === 'Email') {
        continue;
      } else if (activity.type === ActivityType.FollowUp) {
        if (!this.isFollowUpTasksVisible) continue;
        if (!this.hasSuggestedTaskEnabled && activity['planType'] == FOLLOW_UP_TYPE.SUGGESTED) continue;
        if (activity['planType'] == FOLLOW_UP_TYPE.SUGGESTED && activity['state'] === 2 && activity['status'] === 6) continue;
      } else if (!this.isOrderActivitiesEnabled && activity.type === ActivityType.Order) {
        continue;
      } else if (!this.isProcedureLogActivitiesEnabled && activity.type === ActivityType.SurgeryOrder) {
        continue;
      } else if (!this.isProcedureTrackerActivitiesEnabled && activity.type === ActivityType.ProcedureTracker) {
        continue;
      } else if (!this.isSetBookingActivitiesEnabled && activity.type === ActivityType.SetBooking) {
        continue;
      } else if (!this.isMedicalInquiryEnabled && activity.type === ActivityType.MedicalInquiry) {
        continue;
      }

      if (activity.type === ActivityType.SurgeryOrder &&
        activity.status === 548910005 &&
        this.authenticationOfflineService.user.buSettings &&
        !this.authenticationOfflineService.user.buSettings['indskr_displaycancelledprocedurelogoncalendar']) {
        continue;
      }

      if (activity.type === ActivityType.Appointment &&
        activity.status === 4 &&
        this.authenticationOfflineService.user.buSettings &&
        !this.authenticationOfflineService.user.buSettings['indskr_displaycancelledmeetingoncalendar']) {
        continue;
      }

      if (this.hasAccountVisitEnabled && (activity as AppointmentActivity).indskr_parentcallid) {
        const parentId: string = (activity as AppointmentActivity).indskr_parentcallid;
        if (!accountVisitNestedMeetingsMap.has(parentId)) {
          accountVisitNestedMeetingsMap.set(parentId, []);
        }
        accountVisitNestedMeetingsMap.get(parentId).push(activity);
        continue;
      }

      filteredActivities.push(activity);
    }

    if (filteredActivities.length === 0) {
      returnedArray.push(...noActivityForToday);
      return returnedArray;
    }

    filteredActivities.sort((activity1, activity2) => {
      if (activity1.scheduledStart.getTime() === 0) return 0;
      if (activity2.scheduledStart.getTime() === 0) return 0;
      if (activity1.scheduledStart > activity2.scheduledStart) return 1;
      if (activity1.scheduledStart < activity2.scheduledStart) return -1;
      return 1;
    });

    let monitorDateArray = [];
    const accountVisitParentIdAndIdx: { id: string, idxToInsert: number }[] = [];

    for (const activity of filteredActivities) {
      const currentDayOfMonth = activity.scheduledStart.toDateString().toUpperCase();

      if (monitorDateArray.indexOf(currentDayOfMonth) >= 0) {
        returnedArray.push(activity);
      } else {
        const headerObj = this._getDateHeaderWithDateAndDayFormat(activity);
        returnedArray.push(headerObj);
        returnedArray.push(activity);
        monitorDateArray.push(currentDayOfMonth);
      }

      if (this.hasAccountVisitEnabled && !(activity as AppointmentActivity).indskr_parentcallid) {
        accountVisitParentIdAndIdx.unshift({ id: activity.ID, idxToInsert: returnedArray.length });
      }

      const dateKey = this._getLocalDateKey(activity.scheduledStart);
      hasToday = hasToday || (dateKey === todayKey);
    }

    if (this.hasAccountVisitEnabled && accountVisitParentIdAndIdx.length > 0) {
      for (const parentIdAndIdx of accountVisitParentIdAndIdx) {
        const nestedMeetings = accountVisitNestedMeetingsMap.get(parentIdAndIdx.id);
        if (nestedMeetings && nestedMeetings.length > 0) {
          returnedArray.splice(parentIdAndIdx.idxToInsert, 0, ...nestedMeetings);
        }
      }
    }

    if (!hasToday) {
      this._insertNoActivityForToday(returnedArray, noActivityForToday);
    }

    return returnedArray;
  }


  private readonly profiler = this.featureProfiler.for('activities');

  async ngOnInit() {
    this.profiler.mark('activities_pane_init');
    this.resetFeatureAction();

    this.date_fns_locale = this.localizationService.getDateFnsLocaleObject();

    this.device.isBackgroundUploadInProgressObservable.pipe(takeUntil(this.ngDestroy$)).subscribe(inProgress => {
      this.backgroundUploadInProgress = inProgress;
      this.syncMessage = this.translate.instant('OFFLINE_UPLOAD_IN_PROGRESS');
      this._cd.markForCheck();
    });
    this.device.syncInProgress$.pipe(takeUntil(this.ngDestroy$)).subscribe(inProgress => {
      this.syncInProgress = inProgress;
      if (!this.backgroundUploadInProgress) {
        this.syncMessage = this.translate.instant('UPLOAD_IN_PROGRESS');
      }
      this._cd.markForCheck();
    });
    this.device.isDataLoadFromLocalDB.pipe(takeUntil(this.ngDestroy$)).subscribe((inProgress) => {
      this.localDbDataLoadInProgress = inProgress;
      this.syncMessage = this.translate.instant('INIT_DATA_IN_PROGRESS');
      this._cd.markForCheck();
    });
    const filters = this.searchConfigService.getDefaultFilters("Home");
    if (filters && filters.length > 0) {
      this.activityService.multiOptionActivityFilter = filters;
      this.events.publish('filterActivitiesDataForSelectedUser', 'MultipleOptionFilter');
    } else {
      this.activityService.filterActivities(this.activityService.activityFilter);
    }
    this.setupVirtualScroll();
    this.profiler.measure('activities_pane_init', 'activities_pane_init');
  }

  private setupVirtualScroll() {
    const activities$ = this.groupedActivities$.pipe(
      filter(items => !!items),
      distinctUntilChanged(),
      tap(items => {
        this._viewdataCache.clear();
        this.buildPrefix(items);
        if (this.startItemIndex != null && this.startItemIndex >= items.length) {
          this.startItemIndex = Math.max(0, items.length - 1);
        }
      }),
      shareReplay(1)
    );
    const jumpToDate$ = this._scrollToDate$.pipe(
      tap(() => this.startItemIndex = undefined),
      tap(date => {
        this.uiService.selectedCalendarDateInWeekView = date;
        this.events.publish('updatedDayClick');  
      }),
      map(date => ({ type: 'jumpToDate' as const, date }))
    );
    const jumpToActivity$ = this.activityService.selectedActivity$.pipe(
      filter(activity => !!activity),
      map(activity => ({ type: 'jumpToActivity' as const, activity }))
    );


    const jumpActions$ = combineLatest([activities$, merge(jumpToDate$, jumpToActivity$)])
      .pipe(
        map(([items, action]) => {
          let scrollY = this.currentScrollY;
          let index: number;

          if (action?.type === 'jumpToDate') {
            index = this.startItemIndex > 0 
              ? this.startItemIndex
              : this._itemIndexByDate(action.date, items);
          } else if (action?.type === 'jumpToActivity') {
            const activityIndex = action.activity?.ID
              ? items.findIndex(item => item.ID === action.activity.ID)
              : this.getPrevSelectedActivityIndex(items);
            if (activityIndex >= 0) {
              index = activityIndex;
            }
          }
          if (index === undefined) {
            return;
          }

          const selectedIndex = Math.max(0, Math.min(index, items.length - 1));

          // Only scroll for activity if NOT already visible
          if (
            action?.type === 'jumpToDate' ||
            selectedIndex <= this.visibleStartIndex ||
            selectedIndex >= this.visibleEndIndex
          ) {
            scrollY = this._prefix[selectedIndex] ?? 0;
          }

          return { type: action.type, scrollY, index: selectedIndex };
        }),
        filter(action => !!action),
        tap((action) => {
        })
      );

    const viewportActions$ = merge(
      jumpActions$,
      this.scroll$
        .pipe(
          map(scrollY => ({ type: 'scroll' as const, scrollY })),
          distinctUntilChanged((prev, curr) => prev.scrollY === curr.scrollY)
        ))
      .pipe(
        // Seed an initial emission so combineLatest fires on first load without
        // waiting for a user scroll or jump (OMNI-58723: list blank until tap)
        startWith({ type: 'scroll' as const, scrollY: this.currentScrollY ?? 0 }),
      );

    combineLatest([
      activities$,
      this.resizeObserver.pipe(filter(height => !!height)),
      viewportActions$
    ])
      .pipe(
        map(([items, viewportHeight, action]) => {
          // If the action is a scroll and the scroller is available, get the scrollY from the scroller
          if (action?.type === 'scroll' && this._scroller) {
            action.scrollY = this._scroller.scrollTop;
          }
          let scrollY = action.scrollY ?? 0;
          items ??= [];

          if (items.length === 0) {
            this.visibleItems = [];
            this.topPad = 0;
            this.startItemIndex = 0;
            this.visibleStartIndex = 0;
            this.visibleEndIndex = 0;
            this.currentScrollY = 0;
            if (this._scroller) this._scroller.scrollTop = 0;
            this._cd.markForCheck();
            return { scrollY: 0, totalHeight: 0, viewportHeight, items };
          }

          const maxScroll = Math.max(0, this.totalHeight - viewportHeight);
          const clampedY = Math.min(Math.max(scrollY, 0), maxScroll);
          let start = this.findIndexForOffset(items, clampedY);

          // Calculate visible range
          let end = start;
          let span = 0;
          while (end < items.length && span < viewportHeight) {
            span += this.getItemSize(items[end]);
            end++;
          }

          this.visibleStartIndex = start;
          this.visibleEndIndex = end;
          end = Math.min(end + 3, items.length); // small buffer
          start = Math.max(start - 5, 0);
          this.visibleItems = items.slice(start, end);
          this.topPad = this._prefix[start];
          this.startItemIndex = start;

          return {
            start,
            end,
            scrollY,
            totalHeight: this.totalHeight,
            viewportHeight,
            items
          };
        }),
        withLatestFrom(this._scroller$),
        distinctUntilChanged(([prev], [curr, scroller]) => isEqual(prev, curr) && this.currentScrollY === curr.scrollY && scroller && scroller.scrollTop === curr.scrollY),
        tap(([{ start, items }]) => {
          const firstActivity = items.find(
            (_, idx) => idx >= start && !items[idx].isDivider
          );
          if (firstActivity) {
            this.scrolledDateChange$.next(firstActivity.scheduledStart);
          }
        }),
        tap(([{ scrollY }, scroller]) => {
          requestAnimationFrame(() => {
            scroller.scrollTo({ top: scrollY, behavior: 'instant' });
          });
          this.currentScrollY = scrollY;
          this._cd.markForCheck();
        }),
        takeUntil(this.ngDestroy$)
      ).subscribe();
  }

  public get showSyncBanner(){
    return this.authenticationOfflineService.showSyncBanner
  }

  public segmentClick(){
    if (this.uiService.activitiesPageTab === 'agenda') {
      this.agendaFooterService.actSegment = 'agenda';
      this.agendaFooterService.initButtons(AgendaFooterView.Act);
    }
  }

  ngOnDestroy() {
    this.ngDestroy$.next(true);
    this.ngDestroy$.complete();
    this.events.unsubscribe('scrollToDate');
  }

  private getPrevSelectedActivityIndex(items: any[]) {
    if (!this.activityService.shouldScrollToPrevSelectedActivity) return;
    if (!this.activityService.prevSelectedActivity) return;
    this.activityService.shouldScrollToPrevSelectedActivity = false;
    let activityToScrollInto = this.activityService.prevSelectedActivity;
    if (this.activityService.prevSelectedActivity.type === 'Sample' && Array.isArray(items) && items.length > 0) {
      const idx = items.findIndex((o) => o.ID === this.activityService.prevSelectedActivity.ID);
      if (idx >= 0) {
        this.activityService.prevSelectedActivity = items[idx];
      }
    }

    const accountVisitRecordCheckResponse = this.activityService.selectedActivity instanceof AppointmentActivity
      ? this.activityService.accountVisitRecordCheck(this.activityService.selectedActivity as AppointmentActivity)
      : undefined;
    if (accountVisitRecordCheckResponse?.isAccountVisitNestedMeeting) {
      const parent = this.activityService.getActivityByID((activityToScrollInto as AppointmentActivity).indskr_parentcallid);
      activityToScrollInto = parent ? parent : activityToScrollInto;
    }
    const activityIndex = items.findIndex((o) => o.ID === activityToScrollInto.ID);
    return activityIndex;
  }

  ngAfterViewChecked() {
    if ((this.device.shouldBeMobileView && !this.uiService.showRightPane) || !this.device.shouldBeMobileView || this.activityService.inboundMeetingFlagForActivitiesPane) {
      if (this.activityService.isComingFromOtherPage) {
        if (this.activityService.selectedActivity) {
          this.openActivityDetails(this.activityService.selectedActivity);
        }
        this.activityService.isComingFromOtherPage = false;
      }
      if (this.activityService.isNewActivityCreated) {
        if (this.activityService.selectedActivity) {
          this.openActivityDetails(this.activityService.selectedActivity, false, true);
        }
        this.activityService.isNewActivityCreated = false;
      }
      if (this.activityService.inboundMeetingFlagForActivitiesPane) {
        if (this.activityService.selectedActivity) {
          this.openActivityDetails(this.activityService.selectedActivity, true, true);
        }
        this.activityService.inboundMeetingFlagForActivitiesPane = false;
      }
    }
  }

  private buildPrefix(items: any[]) {
    items ??= [];
    this._prefix = new Array(items.length + 1);
    this._prefix[0] = 0;
    for (let i = 0; i < items.length; i++) {
      this._prefix[i + 1] = this._prefix[i] + this.getItemSize(items[i]);
    }
    this.totalHeight = this._prefix[items.length];
  }

  private getItemSize(item: any): number {
    if (item.isDivider) return 28;
    if (item.noActivity) return 75;
    return 75;
  }  
  
  onScroll(e: Event) {
    this.scroll$.next((e.target as HTMLElement).scrollTop);
  }

  // Find the largest i such that prefix[i] <= scrollY
  private findIndexForOffset(items: any[], scrollY: number): number {
    let lo = 0, hi = this._prefix.length - 1; // prefix has n+1 entries
    while (lo <= hi) {
      const mid = (lo + hi) >>> 1;  // fast floor((lo+hi)/2)
      if (this._prefix[mid] <= scrollY) {
        lo = mid + 1;
      } else {
        hi = mid - 1;
      }
    }
    // hi ends up as the index of the row that starts at or before scrollY
    return Math.max(0, Math.min(hi, items.length - 1));
  }

  trackByIndex(index: number): number {
    return index;
  }

  trackByActivityId(_, activity) {
    if (!activity) return '';
    if (activity.isDivider) {
      return activity.label + '-divider';
    }
    if (activity.noActivity) {
      return 'no-activity';
    }
    return activity.ID ?? activity.id;
  }

  private refreshScroll(isScrollToDate: boolean = false) {
    if (this.activityService.selectedActivity
      && this.lastActiveSegment == 'agenda'
      && this.activityService.selectedActivityOnAgenda
      && this.activityService.selectedActivity?.ID !== this.activityService.selectedActivityOnAgenda.ID) {
        this.openActivityDetails(this.activityService.selectedActivityOnAgenda);
      }
    if (isScrollToDate && this.activityService.activityOpenedFromTodo && this.lastActiveSegment == 'agenda') {
      this.activityService.activityOpenedFromTodo = false;
      this.scrollToDate();
    }
    this.activityService.selectedActivityOnAgenda = undefined;
  }

  _itemIndexByDate(date: Date, items: any[]) {
    if (this.activityService.selectedActivity?.ID) {
      const selectedActivityDate = new Date(this.activityService.selectedActivity.scheduledStart);
      
      if (selectedActivityDate.getDate() === date.getDate() && 
          selectedActivityDate.getMonth() === date.getMonth() && 
          selectedActivityDate.getFullYear() === date.getFullYear()) {
        
        // Find the first item that is at or after the selected activity's time
        for (let i = 0; i < (items?.length ?? 0); i++) {
          const item = items[i];
          if (!item.isDivider && !item.noActivity && item.scheduledStart >= selectedActivityDate) {
            return i;
          }
        }
      }
    }
    
    // Fallback to original start-of-day logic
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    let idx = sortedIndexBy(items, { scheduledStart: date }, 'scheduledStart');
    if(idx >= items?.length && idx != 0){
      date = cloneDeep(items[idx-1].scheduledStart);
      idx = sortedIndexBy(items, { scheduledStart: date }, 'scheduledStart');
    }
    
    return idx;
  }

  scrollToDate(date: Date = new Date()) {
    this._scrollToDate$.next(date);
  }

  resetFeatureAction() {
      this.hasBaselineEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.BASELINE) ? true : false;
      this.hasTimeoffEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.TIME_OFF_TOOL) ? true : false;
      this.hasSamplingEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ALLOCATION_TOOL) ? true : false;
      this.hasEmailEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MESSAGE_ACTIVITY) ? true : false;
      this.hasPhoneCallEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.PHONECALL_ACTIVITY) ? true : false;
      this.hasCustomerInquiries = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE) ? true : false;
      this.isOrderActivitiesEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ORDER_MANAGEMENT) ? true : false;
      this.isProcedureLogActivitiesEnabled = this.authenticationOfflineService.user.hasProcedureLog;
      this.isProcedureTrackerActivitiesEnabled = this.authenticationOfflineService.user.hasBulkProcedureLog;
      this.hasEdgeAnalyticsEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.EDGE_ANALYTICS_MEETING)? true: false;
      this.hasSuggestedMeetingsEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.SHOW_SUGGESTED_MEETINGS);
      this.hasSuggestedTaskEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.SHOW_SUGGESTED_TASKS);
      this.hasAccountVisitEnabled = !!(this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ACCOUNT_VISIT));
      this.isSetBookingActivitiesEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.KIT_BOOKING);
      this.isMedicalInquiryEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MEDICAL_INQUIRY_TOOL);
    this.isFollowUpTasksVisible = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.FOLLOW_UP_ACTION_ACTIVITY) ? true : false;

  }


  /**
   * Custom track by fn for performance
   * @param index
   * @param item
   */
  tbFn(index, item) {
    return item.list[0].id;
  }

  private readonly _scroller$ = new BehaviorSubject<HTMLDivElement>(null);
  private get _scroller(): HTMLDivElement {
    return this._scroller$.getValue();
  }
  private readonly _scrollToDate$ = new BehaviorSubject<Date>(new Date());
  private readonly resizeObserver = this._scroller$
    .pipe(
      distinctUntilChanged(),
      filter(elementRef => !!elementRef),
      switchMap((elementRef) => {
        return new Observable<number>(observer => {
          const emitHeight = () => {
            // ResizeObserver callbacks fire outside Angular's zone — re-enter
            // so the combineLatest emission triggers change detection (OMNI-58723)
            if (NgZone.isInAngularZone()) {
              observer.next(elementRef.clientHeight);
            } else {
              this._ngZone.run(() => observer.next(elementRef.clientHeight));
            }
          };
          const resizeObs = new ResizeObserver(() => emitHeight());
          resizeObs.observe(elementRef);
          let rafId = 0;
          let attempts = 0;
          const seedHeight = () => {
            if (elementRef.clientHeight > 0) {
              emitHeight();
              return;
            }
            if (attempts++ < 30) {
              rafId = requestAnimationFrame(seedHeight);
            }
          };
          seedHeight();
          return () => {
            cancelAnimationFrame(rafId);
            resizeObs.disconnect();
          };
        });
      }),
      // Dedupe before dropping 0: a hide/show at the same height must re-emit, or rows computed while hidden stay misplaced.
      distinctUntilChanged(),
      filter(height => !!height),
    );

  @ViewChild('scroller') set scroller(scroller: ElementRef<HTMLDivElement>) {
    if (this._scroller === scroller?.nativeElement) return; // Avoid unnecessary updates
    if (!scroller?.nativeElement) return;
    this._scroller$.next(scroller.nativeElement);
  }

  ngAfterViewInit() {
    this.activityService.scrolledOnce = false;
    this.scrollDate = new Date(this.activityService.getScrollDate);
    this.refreshAgenda();
  }

  /**
   * Returns true if we have nothing to show for yesterday today and tomorrow, used to show the no activities message
   *
   * @readonly
   * @type {boolean}
   * @memberof ActivitiesPaneComponent
   */
  get displayNoActivities(): boolean {
    if (this.activityService.activityFilter === ActivityType.AllActivity) {
      if (this.activityService.activities && this.activityService.getActivitiesByStartDate) {
        return (this.activityService.getActivitiesByStartDate.length == 0);
      }
    } else if (this.activityService.activityFilter === ActivityType.Appointment) {
      if (this.activityService.filteredAppointments) {
        return (this.activityService.filteredAppointments.length == 0);
      }
    } else if (this.activityService.activityFilter === ActivityType.TimeOff) {
      if (this.activityService.filteredTimeOffs) {
        return (this.activityService.filteredTimeOffs.length == 0);
      }
    }
    return false;
  }

  /**
   * Gets activity icons based on activity type
   *
   * @memberof ActivitiesPaneComponexnt
   */
  getTypeImage = (activityType): string => {
    return this.activityService.getActivityIcon(activityType);
  }
  /**
   * Expand activity time and delete options
   *
   * @memberof ActivitiesPaneComponent
   */
  expandList = (event, activityItem: Activity): void => {
    activityItem.expanded = !activityItem.expanded;
    activityItem.expandIcon = (activityItem.expanded) ? 'accordion-minus' : 'accordion-add';
    if(event){
      event.stopPropagation();
    }
  }
  /**
   * Opens Activity details screen by setting activity service selected property
   *
   * @memberof ActivitiesPaneComponent
   */
  async openActivityDetails(activity, isInboundFlow = false, isNewlyCreatedActivity = false, fetchData = true) {
    this.profiler.mark('activities_open_detail');
    let flag = await this.setBookingDataService.checkSetBookingDiscardConfirmationRequired().catch(err=>{});
    if(flag){
      this.uiService.showNewActivity = false;
      this.uiService.activeView = 'ActivitySkeleton';
      this._cd.markForCheck();
      setTimeout(()=>{
            this.activityOpenedFromActivities.emit({activity, isInboundFlow, isNewlyCreatedActivity, fetchData});

      },1)
    }
  }

  async openActivitiesFilter(ev: Event) {
    let flag = await this.setBookingDataService.checkSetBookingDiscardConfirmationRequired().catch(err=>{});
    if(!flag) return;
    this.trackingService.tracking('AgendaActivitiesFilterClicked', TrackingEventNames.ACTIVITY)

    if(this.authenticationOfflineService.user.buConfigs['indskr_multicalendar']){ // Check for enabling multi calendar feature
      this._handleActTabActivityFilter();
    } else {
      let popover = await this.popoverCtrl.create({
        component: ActivitiesFilterPopoverComponent,
        cssClass: 'activities-filter',
        event: ev
      })
      popover.present();
      popover.onDidDismiss().then((data) => {
      })
    }
  }

  /**
   * Filter Activity based on select option value
   *
   * @param {any} activityType
   * @memberof ActivitiesPaneComponent
   */
  filterAgendaData(activityType?: string) {
    if (this._isFilteringInProgress) {
      return;
    }
    this.profiler.mark('activities_filter');
    this._isFilteringInProgress = true;
    
    if (activityType && activityType != 'All Activities' && this.activityService.selectedActivity
      && this.activityService.selectedActivity.type != activityType)  {
        this.activityService.selectedActivity = undefined;
        if (this.navService.getActiveChildNavName() === ChildNavNames.ActivitiesPageNavigation) {
          this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView);
        }
      }
    let isTeamViewUserSelection = false;
    if (!activityType && !this.activityService.multiOptionActivityFilter) {
      activityType = this.activityService.activityFilter;
      isTeamViewUserSelection = true;
    }
    if(this.activityService.multiOptionActivityFilter){
      try {
        let selActivityTypeOptions = this.activityService.multiOptionActivityFilter.filter(a => a.categoryPath == "Activity_Type");
        if(selActivityTypeOptions.length == 0){
          this.activityService.activityFilter = 'All Activities';
        }else{
          this.activityService.activityFilter = selActivityTypeOptions[0].value;
        }
        this.activityService.activityFilterValue = this.translate.instant(this.translateSelectedOptions(ActivityTypeToFilterNameMap[this.activityService.activityFilter]));
        if(this.activityService.multiOptionActivityFilter.length > 1){
          let numOfSelectedPositions = this.activityService.multiOptionActivityFilter.filter(cat => cat.categoryPath === 'Positions').length;
          if((this.activityService.multiOptionActivityFilter.length-numOfSelectedPositions -1) > 0)
            this.activityService.activityFilterValue = this.activityService.activityFilterValue +' +'+(this.activityService.multiOptionActivityFilter.length-numOfSelectedPositions -1);
        }
      } catch (error) {
      }
    }else{
      this.activityService.activityFilter = activityType;
      this.activityService.activityFilterValue = ActivityTypeToFilterNameMap[activityType]
      this.activityService.activityFilterValue = this.translateSelectedOptions(ActivityTypeToFilterNameMap[activityType]);
    }

    if(this.activityService.activityFilterValue.indexOf('Customer')>-1){
      this.activityService.activityFilterValue = this.activityService.activityFilterValue.replace('Customer',this.globalCustomerText);
    }
    if(this.activityService.activityFilterValue.indexOf('Stakeholder')>-1){
      this.activityService.activityFilterValue = this.activityService.activityFilterValue.replace('Stakeholder',this.globalCustomerText);
    }
    
    this.activityService.filterActivities(activityType);

    // Any filter change (apply or clear) should re-anchor the agenda to today.
    // We set a flag here and honour it inside refreshAgenda() — after
    // groupedActivities$.next() has emitted the rebuilt activity list — so that
    // combineLatest fires with the new dataset and today's date together.
    // Calling scrollToDate() before groupedActivities$.next() fires it against
    // the still-filtered list, which may have no activities on today. (OMNI-60683)
    if (!this.uiService.toolsActivityActive) {
      this._scrollToTodayAfterRefresh = true;
    }

    if (!this.uiService.toolsActivityActive) {
      this.events.publish('refreshAgenda');
    } else {
      this.uiService.agendaRefreshRequired = true;
    }

    if (isTeamViewUserSelection) {
      this.activityService.publishActivityDataFilterEvent({ filterType: 'teamView' });
    } else {
      this.activityService.publishActivityDataFilterEvent({ filterType: 'activityType' });
    }

    this.filterAtHome = this.activityService.activityFilter;
    this.filterValueAtHome = this.activityService.activityFilterValue;
    this.profiler.measure('activities_filter', 'activities_filter', { filterType: activityType });
    this._isFilteringInProgress = false;
  }

  translateSelectedOptions(selectedOption:string){

    switch (this.utilityService.globalCustomerText) {
      case 'Customer':
        this.globalCustomerText = this.translate.instant('CUSTOMER');
        break;
      case 'Stakeholder':
        this.globalCustomerText = this.translate.instant('STAKEHOLDER');
        break;
      default:
        this.globalCustomerText = this.utilityService.globalCustomerText;
        break;
    }
    switch(selectedOption){
     case 'All Activities':
     return 'HOME';
     case 'Meetings':
     return 'MEETINGS';
     case 'Phone Calls':
      return 'PHONE_CALLS';
     case 'Messages':
     return 'MESSAGES';
     case 'Time Off':
     return 'TIME_OFF';
     case 'Joint Meetings':
     return 'JOIN_MEETING';
     case 'Joint Phone Calls':
     return 'JOINT_PHONE_CALLS';
     case 'Allocation Orders':
     return 'ALLOWCATION_ORDERS';
     case 'Follow-up Actions':
     return 'FOLLOW_UP_ACTIONS';
     case 'Follow-up':
     return 'FOLLOW_UP';
     case 'Order':
     return 'NEW_ACTIVITY_ORDER';
     case 'Sales Orders':
     return 'ACCOUNT_TIMELINE_OPTION_ORDERS';
     case 'Surgery Orders':
     return 'PROCEDURE_LOGS';
     case 'Customer Inquiries':
     return  this.translate.instant('CUSTOMER_INQUIRIES', { globalCustomerText: this.globalCustomerText });
     case 'LiveMeet':
     return 'LIVE_MEETING';
     case 'StoreCheck': return 'STORE_CHECKS'
     case 'SetBooking':
      return 'KIT_BOOKINGS'
     case 'Medical Inquiries':
      return 'MEDICAL_INQUIRY_TOOL';
     default:
     return selectedOption;
    }
}


  onStopImpersonation() {
    this.trackingService.tracking('UserSelectionRemoved', TrackingEventNames.ACTIVITY);
    this.authenticationOfflineService.impersonatedUser = undefined;
    this.activityService.selectedActivity = undefined;
    this.activityService.agendaTeamViewActivities = [];
    if(this.activityService.multiOptionActivityFilter){
      this.activityService.multiOptionActivityFilter = this.activityService.multiOptionActivityFilter.filter(a => a.categoryPath == "Activity_Type");
    }
      this.navService.setChildNavRoot(PageName.NothingSelectedView,PageName.NothingSelectedView,PageName.GoAppActivitiesPageComponent);
    this.filterAgendaData();
  }

  /**
   * Set List header text based on date
   *
   * @param {any} value
   * @returns {string}
   * @memberof ActivitiesPaneComponent
   */
  public formatHeader(value): string {
    let edge = window.navigator.userAgent.indexOf('Edge/');
    let formatedDate: any;
    if (edge > 0) {
      let tempDate = value.split("-");
      let currentMonthIndex: number;
      let filteredMonth = this.months.filter((month: string, index: number) => {
        let compare = month.substring(0, 3);
        currentMonthIndex = index;
        return compare === tempDate[1];
      });
      let realDate = new Date(Date.parse(tempDate[0] + " " + tempDate[1] + " " + tempDate[2]));
      let dayOfTheWeek = this.weekDay[realDate.getDay() - 1];
      tempDate = dayOfTheWeek + " " + filteredMonth[filteredMonth.length - 1] + " " + tempDate[0];
      formatedDate = parseInt(window.navigator.userAgent.substring(edge + 5, window.navigator.userAgent.indexOf('.', edge)), 10) >= 16 ? tempDate : value;
    } else {
      formatedDate = this.dateTimeFormatService.isTodayDate(value) ? 'Today' : this.dateTimeFormatService.isTomorrowDate(value) ? 'Tomorrow' : this.getFormattedAndLocalisedDate(value);
    }
    return formatedDate;
  }

  private getFormattedAndLocalisedDate(value: any) {
    return this.datepipe.transform(value, this.dateTimeFormatService.date, undefined, this.translate.currentLang);
  }
  /**
   * Sets Todays header color to Blue
   *
   * @param {any} value
   * @returns
   * @memberof ActivitiesPaneComponent
   */
  public setHeaderColor(value) {
    let headerColor = this.dateTimeFormatService.isTodayDate(value) ? "primary" : 'light';
    return headerColor;
  }

  public isLabelToday(activity):boolean {
    let flag:boolean = false;
    if(activity && activity.scheduledStart){
      const today = new Date();
      const currentDate = today.toDateString().substr(0, 10).toUpperCase();
      if(currentDate == activity.scheduledStart.toDateString().substr(0, 10).toUpperCase()){
        flag = true;
      }
    }
    return flag;
  }

  /**
   *
   *
   * @param {*} date
   * @returns {string}
   * @memberof ActivitiesPaneComponent
   */
  formatActivityGroupDate(date: any): string {
    return this.dateTimeFormatService.formatDate(new Date(date), 'DD-MM-YYYY'); // this is use to tag the item group for agenda
  }

  async confirmRemoteMeetingdisconnect(activity) {
    let response = await this.activityService.cancelRemoteMeeting();
    if (response) {
      this.websocket.meetingInProgress = false;
      this.activityService.didOpenDetailPageFromAgendaPage = true;
      this.activityService.prevSelectedActivity = this.activityService.selectedActivity;
      this.meetingService.updateContactJoinDetailsLeftDate(this.activityService.selectedActivity, true);
      this.openActivityDetails(activity);
    }
  }

  public getActivitySecondaryTextStringForFollowup(activity: FollowUpActivity): string {
    if (activity) {
      return this.followUpDataService.getActivitySecondaryTextStringForFollowup(activity);
    }
  }

  private getActivitySecondaryTextStringForStoreCheck(activity: StoreCheckActivity) : string{
    return activity && !isEmpty(activity.categoryId) ? activity.categoryName : this.translate.instant('XPERIENCES_RELATIONSHIP_NO_CATEGORY');
  }

  public deleteCI(e) {
    let state: string = String(e._case_status_value).toLocaleLowerCase();
    if (state != 'open' && state != 'pending sync') {
      return;
    }
    this.caseManagementService.assignSelectedCase(e);

    this.alertService.showAlert({
      header: this.translate.instant('POP_SCRAP_INQUIRY'),
      message: this.translate.instant('POP_R_U_SURE_SCRAP_SELECTED_INQUIRY')}, this.translate.instant('SCRAP')
    ).then (res => {
      if(res.role == "ok") {
        this.trackingService.tracking('InquiryActivityScrapAgenda', TrackingEventNames.CUSTOMER_INQUIRY)
        this.caseManagementService.scrapCustomerInquiry(<CaseActivity>e);
      }
    });
  }


  private _doesDateHeaderExistForGivenActivityDate(activities, previousItemIndex, activity) {
    const prevListItem = activities[previousItemIndex];

    let dateDiff = 0;
    if (!prevListItem.isDivider) {
      dateDiff = this.dateTimeFormatService.getDifferenceInCalendarDays(prevListItem.scheduledStart, activity.scheduledStart);
    }
    return !prevListItem ? false : !(!prevListItem.isDivider && dateDiff !== 0);
  }

  private _createNoActivityForTodayItems(today: Date): Object[] {
    return [{
      isDivider: true,
      label: today.toDateString().toUpperCase(),
      view: {
        id: '',
        title: this.formatScheduledStart(today),
        controls: [],
      },
      scheduledStart: new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
    }, {
      noActivity: true,
      scheduledStart: new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      )
    }];
  }

  private _getDateHeaderWithDateAndDayFormat(activity) {
    const today = new Date();
    const currentDate = today.toDateString().toUpperCase();
    const headerObj = {
      isDivider: true,
      label: activity.scheduledStart.toDateString().toUpperCase(),
      view: {
        id: '',
        title: this.formatScheduledStart(activity.scheduledStart),
        controls: [],
      },
      scheduledStart: new Date(
        activity.scheduledStart.getFullYear(),
        activity.scheduledStart.getMonth(),
        activity.scheduledStart.getDate()
      )
    }
    return headerObj;
  }

  /**
   * Inserts the "No Activity for Today" message at an appropriate position
   */
  private _insertNoActivityForToday(result: Object[], noActivityForToday: Object[]): void {
    if (result.length === 0) {
      result.push(...noActivityForToday);
      return;
    }

    let insertIndex = 0;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    for (let i = 0; i < result.length; i++) {
      const item = result[i] as any;
      if (item.scheduledStart && item.scheduledStart >= today) {
        insertIndex = i;
        break;
      }
      if (i === result.length - 1) {
        insertIndex = result.length;
      }
    }

    result.splice(insertIndex, 0, ...noActivityForToday);
  }

  private formatScheduledStart(scheduledStart: Date) {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    const isToday = scheduledStart.toDateString() === today.toDateString();
    const isTomorrow = scheduledStart.toDateString() === tomorrow.toDateString();

    const day = isToday ? this.translate.instant('TODAY') : isTomorrow ? this.translate.instant('TOMORROW') : '';
    // const date = scheduledStart.toLocaleDateString(undefined, { day: 'numeric', weekday: 'short' }).split(' ').reverse().join(' ');
    let date = this.dateTimeFormatService.formatDate(scheduledStart, "ddd D MMMM YYYY");
    if (day) {
      date = `${date} - ${day}`;
    }

    return date;
  }

  getSearchBarPlaceholderText(){
    let text:string;
    switch(this.uiService.activitiesPageTab){
      case 'agenda':
        text= this.translate.instant('SEARCH_AGENDA');
        break;
      case 'day':
        text= this.translate.instant('SEARCH_WEEK');
        break;
      case 'scheduler':
        text= this.translate.instant('SEARCH_SCHEDULER');
        break;
    }
    return text;
  }

  onInput(ev){
    if(ev && ev.target){
      this.activityService.activitiesSearchText = ev.target.value;
      if (this.uiService.activitiesPageTab == 'agenda' && this.agendaFooterService.actSegment != 'approvals') {
        this.refreshAgenda();
      }
    }
  }

  newSchedule(){
    this.confirmNewPattern = !this.confirmNewPattern;
  }


  public getMainCardDataModel(targetActivity: Activity) {
    
    // Check if cache has data and validate it against current activity data
    if (this._viewdataCache.has(targetActivity.ID)) {
      const cachedViewData = this._viewdataCache.get(targetActivity.ID);
      
      const shouldBeSelected = this.activityService.selectedActivity?.ID === targetActivity.ID;

      // If this is the selected activity, validate cache against current data
      if (shouldBeSelected) {
        // Check if cached data is different from current activity data
        const currentActivity = this.activityService.getActivityByID(targetActivity.ID);
        if (!currentActivity) {
          return null;
        }
        const viewData = this.getViewData(currentActivity);
        if (this.isViewDataOutdated(cachedViewData, viewData)) {
          // Cache is outdated, remove it and regenerate
          this._viewdataCache.delete(targetActivity.ID);
        } else if (cachedViewData.isSelected !== true) {
          // Create new reference so OnPush main-card detects the change
          const updated = { ...cachedViewData, isSelected: true };
          this._viewdataCache.set(targetActivity.ID, updated);
          return updated;
        } else {
          return cachedViewData;
        }
      } else if (cachedViewData.isSelected !== false) {
        // Create new reference to deselect
        const updated = { ...cachedViewData, isSelected: false };
        this._viewdataCache.set(targetActivity.ID, updated);
        return updated;
      } else {
        return cachedViewData;
      }
    }

    const activity = this.activityService.getActivityByID(targetActivity.ID);
    if (!activity) {
      return null;
    }   
    
    // Generate fresh view data and cache it
    const viewData = this.getViewData(activity);
    this._viewdataCache.set(activity.ID, viewData);
    return viewData;
  }

  getViewData(activity: Activity) {

    let setTimeOffTime = new Date();
    let setTimeOffStartTime = new Date();
    let setTimeOffEndTime = new Date();
    let formattedTimeOffTimeText: string = '';
    let tot: TimeOffActivity = <TimeOffActivity>activity;
    if(activity.type === ActivityType.TimeOff || activity.type === ActivityType.TimeOffRequest) {
      setTimeOffTime.setTime(activity.scheduledStart.getTime());
      switch(tot.durationType) {
        case 'All Day':
          setTimeOffTime.setHours(24);
          setTimeOffTime.setMinutes(0);
          formattedTimeOffTimeText = this.dateTimeFormatService.formatDate(setTimeOffTime, this.dateTimeFormatService.timeFormatSelected.segment); // all day format
          break;
        case 'Half Day':
          setTimeOffTime.setMinutes(0);
          (activity.scheduledStart.getHours() < 12)?setTimeOffTime.setHours(24):setTimeOffTime.setHours(12);
          formattedTimeOffTimeText = this.dateTimeFormatService.formatDate(setTimeOffTime, this.dateTimeFormatService.timeFormatSelected.segment); // half day format
          break;
        case 'Hourly':
          setTimeOffStartTime.setTime(activity.scheduledStart.getTime());
          setTimeOffEndTime.setTime(activity.scheduledEnd.getTime());
          if(activity.scheduledStart.getHours() == 0 && activity.scheduledStart.getMinutes() == 0 && activity.scheduledEnd.getHours() == 11 && activity.scheduledEnd.getMinutes() == 59 ||
            activity.scheduledStart.getHours() == 12 && activity.scheduledStart.getMinutes() == 0 && activity.scheduledEnd.getHours() == 23 && activity.scheduledEnd.getMinutes() == 59) {
            setTimeOffTime.setMinutes(0);
            (activity.scheduledStart.getHours() < 12)?setTimeOffTime.setHours(24):setTimeOffTime.setHours(12);
            formattedTimeOffTimeText = this.dateTimeFormatService.formatDate(setTimeOffTime, this.dateTimeFormatService.timeFormatSelected.segment); // half day format
          } else {
            formattedTimeOffTimeText = this.dateTimeFormatService.formatDate(setTimeOffStartTime, this.dateTimeFormatService.timeFormatSelected.segment)+' - '+this.dateTimeFormatService.formatDate(setTimeOffEndTime, this.dateTimeFormatService.timeFormatSelected.segment); // hourly format
          }
          break;
        default:
          break;
      }
    }
    let setFollowUpTime = new Date();
    setFollowUpTime.setHours(24);
    setFollowUpTime.setMinutes(0);

    let viewData: MainCardViewDataModel;
    const isConflicting = this.getIsConflictingForActivity(activity);
    switch (activity.type) {
      case ActivityType.Appointment: {
        const appointmentHandle: AppointmentActivity = (activity as AppointmentActivity);
        const isNestedAccountVisit: boolean = this.hasAccountVisitEnabled && !!(appointmentHandle.indskr_parentcallid);
        const parentAccountVisitId: string = isNestedAccountVisit ? appointmentHandle.indskr_parentcallid : undefined;

        viewData = {
          id: activity.ID,
          fixedHeight: true,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'activitiesList',
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: isNestedAccountVisit
            ? this.dateTimeFormatService.formatDate(appointmentHandle.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment) + ' - ' + this.dateTimeFormatService.formatDate(appointmentHandle.scheduledEnd, this.dateTimeFormatService.timeFormatSelected.segment)
            : this.dateTimeFormatService.formatDate(activity.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment) + ' - ' + this.dateTimeFormatService.formatDate(activity.scheduledEnd, this.dateTimeFormatService.timeFormatSelected.segment),
          primaryTextRight: isNestedAccountVisit
            ? appointmentHandle.contacts && appointmentHandle.contacts[0]?.fullName || this.translate.instant('MEETING')
            : activity.subject == 'Meeting' ? this.translate.instant('MEETING') : (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT) && activity.subject == 'Visit') ? this.translate.instant('VISIT') : activity.subject,
          secondaryTextRight: isNestedAccountVisit
            ? undefined
            : (!activity.location || activity.location == 'nan') ? this.translate.instant('NO_LOCATION') : (activity.location == 'No Location' ? this.translate.instant('NO_LOCATION') : activity.location),
          showArrow: false,
          showIcon: true,
          iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
          isConflicting,
          mainItemCssClass: isNestedAccountVisit ? 'first-nested-item' : '',
          clickHandler: (id: string, event, specificTarget) => {
            const foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget == 'delete_control') {
                this.events.publish('deleteMeeting', foundActivity);
              }
              else if (specificTarget && specificTarget == 'endArrow') {
                this.expandList(event, activity)
              } else if (specificTarget && specificTarget == 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              } else if (!isEmpty(foundActivity['indskr_teamslink'])) {
                this.openActivityDetails(foundActivity);
              } else if (this.websocket.meetingInProgress || this.activityService.isThereConnectedContactsForCurrentMeeting(<AppointmentActivity>this.activityService.selectedActivity, true)) {
                if (this.activityService.selectedActivity?.ID !== activity?.ID) {
                  this.confirmRemoteMeetingdisconnect(foundActivity);
                }
              } else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        break;
      }
      case ActivityType.PhoneCall:
        viewData = {
          id: activity.ID,
          fixedHeight: true,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'activitiesList',
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: this.dateTimeFormatService.formatDate(activity.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment),
          primaryTextRight: this.activityService.getActivitysubject(activity),
          secondaryTextRight: ((activity as PhoneActivity).selectedMobileNumber == "" || (activity as PhoneActivity).selectedMobileNumber == null || (activity as PhoneActivity).selectedMobileNumber == undefined) ? this.translate.instant('NO_CONTACT_NUMBER') : (activity as PhoneActivity).selectedMobileNumber,
          showArrow: false,
          showIcon: true,
          iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
          isConflicting,
          clickHandler: (id: string, event, specificTarget) => {
            let foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget == 'delete_control') {
                this.events.publish('deleteMeeting', foundActivity);
              }
              else if (specificTarget && specificTarget == 'endArrow') {
                this.expandList(event, activity)
              } else if (specificTarget && specificTarget == 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              }
              else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        break;
      case ActivityType.Sample:
        viewData = {
          id: activity.ID,
          fixedHeight: true,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'activitiesList',
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: this.dateTimeFormatService.formatDate(activity.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment),
          primaryTextRight: (activity as SampleActivity).isPromoMaterial
            ? this.translate.instant('PROMOTIONAL_MATERIAL')
            : ((activity as SampleActivity).orderId ? this.translate.instant('ALLOWCATION_ORDER') + ' - ' + (activity as SampleActivity).orderId : this.translate.instant('ALLOWCATION_ORDER')),
          secondaryTextRight: (!(activity as SampleActivity).contactName) ? this.translate.instant('NO_CONTACT') : (activity as SampleActivity).contactName,
          showArrow: false,
          showIcon: true,
          isSrcAttribute: true,
          iconName: this.activityService.getActivityIcon(activity),
          clickHandler: (id: string, event, specificTarget) => {
            let foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget == 'delete_control') {
                this.events.publish('deleteMeeting', foundActivity);
              }
              else if (specificTarget && specificTarget == 'endArrow') {
                this.expandList(event, activity)
              } else if (specificTarget && specificTarget == 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              }
              else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        break;
      case ActivityType.StoreCheck:
          viewData = {
            id: activity.ID,
            fixedHeight: true,
            isExpandable: true,
            isExpanded: activity.expanded,
            expandableViewType: 'activitiesList',
            expandableData: activity,
            expandHeight: this.itemExpandHeight,
            isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
            primaryTextLeft: this.activityService.getActivityDateRange(activity),
            primaryTextRight: activity.subject == 'Store Check' ? this.translate.instant('STORE_CHECK') : activity.subject,
            secondaryTextRight: this.getActivitySecondaryTextStringForStoreCheck(activity as StoreCheckActivity),
            showArrow: false,
            showIcon: true,
            iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
            clickHandler: (id: string, event, specificTarget) => {
              let foundActivity = this.activityService.getActivityByID(id);
              if (foundActivity) {
                if (specificTarget && specificTarget == 'delete_control') {
                  this.events.publish('deleteMeeting', foundActivity);
                } else if (specificTarget && specificTarget == 'endArrow') {
                  this.expandList(event, activity)
                } else if (specificTarget && specificTarget == 'endIcon') {
                  this._handleMoreOptionsPopover(activity, event);
                } else {
                  this.openActivityDetails(foundActivity);
                }
              }
            }
          };
          break;
      case ActivityType.FollowUp:
        viewData = {
          id: activity.ID,
          fixedHeight: true,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'activitiesList',
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: this.dateTimeFormatService.formatDate(setFollowUpTime, this.dateTimeFormatService.timeFormatSelected.segment),
          primaryTextRight: activity.subject == 'Follow-up Action' ? this.translate.instant('FOLLOW_UP_ACTION') : activity.subject,
          secondaryTextRight: this.getActivitySecondaryTextStringForFollowup(activity as FollowUpActivity),
          showArrow: false,
          showIcon: true,
          iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
          clickHandler: (id: string, event, specificTarget) => {
            let foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget == 'delete_control') {
                this.events.publish('deleteMeeting', foundActivity);
              }
              else if (specificTarget && specificTarget == 'endArrow') {
                this.expandList(event, activity)
              } else if (specificTarget && specificTarget == 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              }
              else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        break;
      case ActivityType.TimeOff:
        viewData = {
          id: activity.ID,
          fixedHeight: true,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'activitiesList',
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: formattedTimeOffTimeText,
          primaryTextRight: activity.subject == 'Time Off' ? this.translate.instant('TIME_OFF') : activity.subject,
          secondaryTextRight: activity.reason ? this.localizationService.getTranslatedString(activity.reason,EntityNameForTranslation.TimeOffReason) : this.translate.instant('NO_REASON'),
          showArrow: false,
          showIcon: true,
          iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
          isConflicting,
          clickHandler: (id: string, event, specificTarget) => {
            let foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget == 'delete_control') {
                this.events.publish('deleteMeeting', foundActivity);
              }
              else if (specificTarget && specificTarget == 'endArrow') {
                this.expandList(event, activity)
              } else if (specificTarget && specificTarget == 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              }
              else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        break;
      case ActivityType.TimeOffRequest:
        viewData = {
          id: activity.ID,
          fixedHeight: true,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'activitiesList',
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: formattedTimeOffTimeText,
          primaryTextRight: activity.subject == 'Time Off' ? this.translate.instant('TIME_OFF') : activity.subject,
          secondaryTextRight: activity.reason ? this.localizationService.getTranslatedString(activity.reason,EntityNameForTranslation.TimeOffReason) : this.translate.instant('NO_REASON'),
          showArrow: false,
          showIcon: true,
          iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
          isConflicting,
          clickHandler: (id: string, event, specificTarget) => {
            let foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget == 'delete_control') {
                this.events.publish('deleteMeeting', foundActivity);
              }
              else if (specificTarget && specificTarget == 'endArrow') {
                this.expandList(event, activity)
              } else if (specificTarget && specificTarget == 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              }
              else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        break;
      case ActivityType.Email:
        viewData = {
          id: activity.ID,
          fixedHeight: true,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'activitiesList',
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: this.emailService.setTimeForMessages(activity as EmailActivity), //Time sent
          primaryTextRight: this.emailService.setPrimaryTextRightForMessages(activity as EmailActivity), //Customer Name
          secondaryTextRight: this.emailService.setSecondaryTextForMessages(activity as EmailActivity), //Channel name
          secondaryTextRightTwo: this.emailService.setSecondaryTextTwoForMessages(activity as EmailActivity), //Template subject
          showArrow: false,
          showIcon: true,
          iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
          clickHandler: (id: string, event, specificTarget) => {
            let foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget == 'delete_control') {
                this.events.publish('deleteMeeting', foundActivity);
              }
              else if (specificTarget && specificTarget == 'endArrow') {
                this.expandList(event, activity)
              } else if (specificTarget && specificTarget == 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              }
              else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        break;
      case ActivityType.Order:
        viewData = {
          id: activity.ID,
          fixedHeight: true,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'activitiesList',
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: this.dateTimeFormatService.formatDate(activity.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment),
          primaryTextRight: this.translate.instant('NEW_ACTIVITY_SALES_ORDER') + ' - ' + activity.subject,
          secondaryTextRight: (!(activity as OrderActivity).accountId) ? this.translate.instant('NO_ACCOUNT') : (activity as OrderActivity).accountNameString,
          showArrow: false,
          showIcon: true,
          iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
          clickHandler: (id: string, event, specificTarget) => {
            let foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget == 'delete_control') {
                this.events.publish('deleteMeeting', foundActivity);
              }
              else if (specificTarget && specificTarget == 'endArrow') {
                this.expandList(event, activity)
              } else if (specificTarget && specificTarget == 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              }
              else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        break;
      case ActivityType.CaseIntake:
        viewData = {
          id: activity.ID,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'customer_inquiry',
          fixedHeight: true,
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: this.dateTimeFormatService.formatDate(activity.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment),
          primaryTextRight: (activity as CaseActivity).caseName,
          showArrow: false,
          showIcon: true,
          iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
          clickHandler: (id: string, event, specificTarget) => {
            let foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget == 'delete_control') {
                this.deleteCI(foundActivity);
              }
              else if (specificTarget && specificTarget == 'endArrow') {
                this.expandList(event, activity)
              } else if (specificTarget && specificTarget == 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              }
              else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        if ((activity as CaseActivity)._case_stage_value) {
          viewData.secondaryTextRight = this.getCaseState((activity as CaseActivity)._case_stage_value);
          viewData.secondaryTextRightTwo = ((activity as CaseActivity)._case_contact) ? (activity as CaseActivity)._case_contact.fullName : ((activity as CaseActivity)._case_trans_customer_name && (activity as CaseActivity)._case_trans_customer_name != Utility.globalCustomerText) ? (activity as CaseActivity)._case_trans_customer_name : `${this.translate.instant('NO')} ${this.utilityService.globalCustomerText}`;
        } else {
          viewData.secondaryTextRight = ((activity as CaseActivity)._case_contact) ? (activity as CaseActivity)._case_contact.fullName : ((activity as CaseActivity)._case_trans_customer_name && (activity as CaseActivity)._case_trans_customer_name != Utility.globalCustomerText) ? (activity as CaseActivity)._case_trans_customer_name : `${this.translate.instant('NO')} ${this.utilityService.globalCustomerText}`;
        }
        break;
      case ActivityType.SurgeryOrder:
        viewData = {
          id: activity.ID,
          fixedHeight: true,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'activitiesList',
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: this.dateTimeFormatService.formatDate(activity.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment) + ' - ' + this.dateTimeFormatService.formatDate(activity.scheduledEnd, this.dateTimeFormatService.timeFormatSelected.segment),
          primaryTextRight: activity.subject,
          secondaryTextRight: this.getSecondaryInfoProcedureLog(activity),
          showArrow: false,
          showIcon: true,
          iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
          clickHandler: (id: string, event, specificTarget) => {
            let foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget == 'delete_control') {
                this.events.publish('deleteMeeting', foundActivity);
              }
              else if (specificTarget && specificTarget == 'endArrow') {
                this.expandList(event, activity)
              } else if (specificTarget && specificTarget == 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              } else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        break;
      case ActivityType.ProcedureTracker:
        viewData = {
          id: activity.ID,
          fixedHeight: true,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'activitiesList',
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: this.dateTimeFormatService.formatDate(activity.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment) + ' - ' + this.dateTimeFormatService.formatDate(activity.scheduledEnd, this.dateTimeFormatService.timeFormatSelected.segment),
          primaryTextRight: activity.subject,
          secondaryTextRight: this.getSecondaryInfoProcedureTracker(activity),
          showArrow: false,
          showIcon: true,
          iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
          clickHandler: (id: string, event, specificTarget) => {
            let foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget == 'delete_control') {
                this.events.publish('deleteMeeting', foundActivity);
              }
              else if (specificTarget && specificTarget == 'endArrow') {
                this.expandList(event, activity)
              } else if (specificTarget && specificTarget == 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              } else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        break;
      case ActivityType.SetBooking:
        viewData = {
          id: activity.ID,
          fixedHeight: true,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'activitiesList',
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: this.dateTimeFormatService.formatDate(activity.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment)+' - '+this.dateTimeFormatService.formatDate(activity.scheduledEnd, this.dateTimeFormatService.timeFormatSelected.segment),
          primaryTextRight: activity.subject,
          secondaryTextRight: this.secInfoConfigDataService.isKitBookingSecInfoConfigured ? this.secInfoConfigDataService.getSecondaryInfoFormatedTextForKitBooking(activity as SetBookingActivity, SecondaryInfoEntityName.Kitbooking) : activity.statusString,
          showArrow: false,
          showIcon: true,
          iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
          clickHandler: (id: string, event, specificTarget) => {
            let foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget == 'delete_control') {
                this.events.publish('deleteMeeting', foundActivity);
              }
              else if (specificTarget && specificTarget == 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              }
              else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        break;
      case ActivityType.MedicalInquiry:
        viewData = {
          id: activity.ID,
          fixedHeight: true,
          isExpandable: true,
          isExpanded: activity.expanded,
          expandableViewType: 'activitiesList',
          expandableData: activity,
          expandHeight: this.itemExpandHeight,
          isSelected: (this.activityService.selectedActivity && this.activityService.selectedActivity.ID == activity.ID),
          primaryTextLeft: format(activity.scheduledStart, this.dateTimeFormatService.timeFormatSelected.segment, this.date_fns_locale),
          primaryTextRight: activity.subject || this.translate.instant('MEDICAL_INQUIRY'),
          secondaryTextRight: (activity as MedicalInquiry).statusCodeFormatted || (activity as MedicalInquiry).contactFormatted || '',
          secondaryTextRightTwo: (activity as MedicalInquiry).statusCodeFormatted ? (activity as MedicalInquiry).contactFormatted || '' : '',
          showArrow: false,
          showIcon: true,
          showEndIcon: false,
          iconName: 'indegene-' + this.activityService.getActivityIcon(activity),
          clickHandler: (id: string, event, specificTarget) => {
            let foundActivity = this.activityService.getActivityByID(id);
            if (foundActivity) {
              if (specificTarget && specificTarget === 'endIcon') {
                this._handleMoreOptionsPopover(activity, event);
              } else {
                this.openActivityDetails(foundActivity);
              }
            }
          }
        };
        break;
    }
    if(!this.activityService.teamViewActive && ((!activity.isCompleted && this.checkCustomScrapCondition(activity)) || this.checkCustomCloneCondition(activity))){
      viewData.showEndIcon = true;
      viewData.isSrcAttribute = true;
      viewData.endIconType = 'assets/imgs/horizontal-menu-filled.svg';
    }
    viewData.highlightedSecondaryText = this.getDaysRemaining(activity.scheduledStart) ?? null;
    
    return viewData;
  }

  /**
   * Checks if cached view data is outdated compared to current view data
   */
  private isViewDataOutdated(cachedViewData: MainCardViewDataModel, viewData: MainCardViewDataModel): boolean {
    if (!cachedViewData || !viewData) {
      return true;
    }
    
    // Check key properties that would make the view data outdated
    return (
      cachedViewData.primaryTextLeft !== viewData.primaryTextLeft ||
      cachedViewData.primaryTextRight !== viewData.primaryTextRight ||
      cachedViewData.secondaryTextRight !== viewData.secondaryTextRight ||
      cachedViewData.isExpanded !== viewData.isExpanded ||
      cachedViewData.expandableData?.scheduledStart?.getTime() !== viewData.expandableData?.scheduledStart?.getTime() ||
      cachedViewData.expandableData?.scheduledEnd?.getTime() !== viewData.expandableData?.scheduledEnd?.getTime() ||
      cachedViewData.expandableData?.subject !== viewData.expandableData?.subject ||
      cachedViewData.expandableData?.location !== viewData.expandableData?.location ||
      cachedViewData.expandableData?.expanded !== viewData.expandableData?.expanded ||
      cachedViewData.expandableData?.isCompleted !== viewData.expandableData?.isCompleted ||
      cachedViewData.isConflicting !== viewData.isConflicting ||
      cachedViewData.iconName !== viewData.iconName
    );
  }

  /**
   * Determines if an activity has conflicts based on its type and properties
   */
  private getIsConflictingForActivity(activity: Activity): boolean {
    switch (activity.type) {
      case ActivityType.Appointment: {
        const appointmentHandle = activity as AppointmentActivity;
        const isNestedAccountVisit = this.hasAccountVisitEnabled && !!(appointmentHandle.indskr_parentcallid);
        
        // For nested account visits, don't show conflicts
        if (isNestedAccountVisit) {
          return false;
        }
        
        // Check for conflicts and close-by activities
        return (
          (activity.conflictingActivityIds instanceof Map && activity.conflictingActivityIds.size > 0) ||
          (activity.closeByActivityIds instanceof Map && activity.closeByActivityIds.size > 0)
        );
      }
      
      case ActivityType.PhoneCall:
      case ActivityType.TimeOff:
      case ActivityType.TimeOffRequest:
        // For these activity types, check only conflicting activities
        return activity.conflictingActivityIds instanceof Map && activity.conflictingActivityIds.size > 0;
        
      default:
        return false;
    }
  }

  private getDaysRemaining(targetDate: Date): string {
    const currentDate = new Date();
    const daysRemaining = this.dateTimeFormatService.getDifferenceInCalendarDays(targetDate, currentDate);

    if (daysRemaining === 0) {
      return this.translate.instant('TODAY');
    } else if (daysRemaining > 0) {
      return daysRemaining + ' ' + (daysRemaining > 1 ? this.translate.instant('DAYS_REMAINING') : this.translate.instant('DAY_REMAINING'));
    } else {
      return null;
    }
  }

  private getSecondaryInfoProcedureLog(activity: Activity): string {
    if ((activity as SurgeryOrderActivity).indskr_noprocedureday) {
      return this.translate.instant('NO_PROCEDURE_DAY');
    } else {
      return (!(activity as SurgeryOrderActivity).accountId) ? this.translate.instant('NO_ACCOUNT') : (activity as SurgeryOrderActivity).accountNameString;
    }
  }

  private getSecondaryInfoProcedureTracker(activity: Activity): string {
    return (!(activity as ProcedureTrackerActivity).accountId) ? this.translate.instant('NO_ACCOUNT') : (activity as ProcedureTrackerActivity).accountNameString;
  }

  public getCaseState(caseState):string{

    switch (caseState) {
        case 'Open':
          caseState = this.translate.instant('OPEN');
            break;
        case 'Approved':
          caseState = this.translate.instant('APPROVE');
            break;
        case 'For Review':
            caseState = this.translate.instant('FOR_REVIEW');
            break;
        case 'In Progress':
            caseState = this.translate.instant('IN_PROGRESS');
            break;
        case 'Intake':
              caseState = this.translate.instant('INTAKE');
              break;
        case 'Pending Sync':
              caseState = this.translate.instant('PENDING_SYNC');
              break;
        default:
            caseState = caseState;
            break;
        }
        return caseState;
}

  private checkIfChannelIsExternal(channelId: string): boolean {
    if (channelId != undefined || channelId != "") {
      const cha: Channel = this.consentService.savedChannels.find(sch => sch.indskr_consenttypeid === channelId);
      if (cha != undefined && cha.indskr_externalchannel === true) {
        return true;
      }
    }
    return false;
  }

  onSearchFocus() {
    this.shouldShowSearchBarFilterButton = false;
  }
  onSearchBlur() {
    this.shouldShowSearchBarFilterButton = this.agendaFooterService.actSegment == 'scheduler'? false : true;
  }
  refreshHeader() {
    if(this.agendaFooterService.actSegment == 'scheduler' || this.agendaFooterService.actSegment == 'approvals') {
      this.shouldShowSearchBarFilterButton = false;
      this.activityService.activityFilter = ActivityType.AllActivity;
      this.activityService.activityFilterValue = this.translate.instant('HOME');
    } else {
      this.shouldShowSearchBarFilterButton = true;
      this.activityService.activityFilter = this.filterAtHome;
      this.activityService.activityFilterValue = this.filterValueAtHome;
    }
  }

  public async createSurgeryOrderCopy (masterSurgeryOrder:SurgeryOrderActivity){
    if(masterSurgeryOrder && this.copySurgeryOrderActivityInProgress == false){
      this.uiService.displayLoader();
      masterSurgeryOrder = this.activityService.getActivityByID(masterSurgeryOrder.ID) as SurgeryOrderActivity;
      this.copySurgeryOrderActivityInProgress = true;
      let copyDTO = masterSurgeryOrder.offlineDataDTO;
      let autoSetOwnerAsCoowner = this.authenticationOfflineService.user.buSettings && this.authenticationOfflineService.user.buSettings['indskr_setownerascoowner'];

      delete copyDTO.indskr_procedurecontract;
      let errorOccured: boolean = false;
      let currentTime = new Date().getTime();
      let start, end;
      start = this.dateTimeFormatService.toISOString(Utility.getRoundedDownTime(new Date()));
      end = this.dateTimeFormatService.toISOString(this.dateTimeFormatService.addMinutesToDate(start, 30));


      let foundTemplate;
      let hideProcedureAndProductCategory = this.authenticationOfflineService.user.buSettings && this.authenticationOfflineService.user.buSettings['indskr_hideprocedureproductcategory'];
      if (hideProcedureAndProductCategory) {
        let procedureLogTypeTemplates = this.surveyService.surveyForms.filter(a => a.templateType == MobileAppTemplateType.ProcedureLogType);
        if (!isEmpty(procedureLogTypeTemplates)) {
          procedureLogTypeTemplates = orderBy(procedureLogTypeTemplates, ['modiefiedOn'], ['desc']);
          foundTemplate = procedureLogTypeTemplates[0];
        }
      } else {
        if (masterSurgeryOrder.surgeryId) {
          const selectedSurgery = this.surgeryOrderActivityDataService.productHierarchies.find(a => a.surgeryId == masterSurgeryOrder.surgeryId);
          if (selectedSurgery && selectedSurgery.surveyTemplateId) {
            foundTemplate = this.surveyService.surveyForms.find(form => form.surveyFormId == selectedSurgery.surveyTemplateId);
          }
        }
      }

      if(foundTemplate){
        await this.surgeryOrderActivityDataService.fetchSurveyJSAtrributesForProcedure(masterSurgeryOrder, foundTemplate);
        foundTemplate = cloneDeep(foundTemplate.surveyConfiguration);
        Object.keys(masterSurgeryOrder.surveyResponseData).forEach((key) => {
          const element = this.surveyService.getElementFromSurveyTemplateElements(foundTemplate.pages[0].elements, { name : key});
          if (element && element.type && element.metadata) {
            if (element.type == "lookup" && masterSurgeryOrder.surveyResponseData[key]) {

              let idx;
              if (!masterSurgeryOrder.surveyResponseDTO.hasOwnProperty('lookupfields')) {
                masterSurgeryOrder.surveyResponseDTO['lookupfields'] = [];
              }
              idx = masterSurgeryOrder.surveyResponseDTO['lookupfields'].findIndex(a => a.name == element.metadata.logicalName);
              if (idx >= 0) {
                if (masterSurgeryOrder.surveyResponseData[key] != masterSurgeryOrder.surveyResponseDTO['lookupfields'][idx].id) {
                  masterSurgeryOrder.surveyResponseDTO['lookupfields'][idx] = {
                    name: element.metadata.logicalName,
                    entity: element.metadata.target.setName,
                    id: masterSurgeryOrder.surveyResponseData[key],
                  };
                }
              } else {
                masterSurgeryOrder.surveyResponseDTO['lookupfields'].push({
                  name: element.metadata.logicalName,
                  entity: element.metadata.target.setName,
                  id: masterSurgeryOrder.surveyResponseData[key],
                });
              }
            } else {
              if (!masterSurgeryOrder.surveyResponseDTO || (masterSurgeryOrder.surveyResponseData[key] != masterSurgeryOrder.surveyResponseDTO[element.metadata.logicalName])) {
                masterSurgeryOrder.surveyResponseDTO[element.metadata.logicalName] = masterSurgeryOrder.surveyResponseData[key];
              }
            }
          }
        });

      }


      copyDTO['salesorderid'] = 'offline_surgeryorder_' + currentTime;
      copyDTO['indskr_externalid'] = 'offline_surgeryorder_' + currentTime;
      copyDTO['pendingPushToDynamics'] = true;
      copyDTO['statuscode'] = 1;
      copyDTO['statecode'] = 0;
      copyDTO['createdon'] = new Date(currentTime).getTime();
      copyDTO['scheduledstart'] = new Date(start).getTime();
      copyDTO['scheduledend'] = new Date(end).getTime();
      copyDTO['indskr_scheduleddate'] = new Date(start).getTime();
      copyDTO['indskr_scheduledenddate'] = new Date(end).getTime();
      copyDTO['contractStatus'] = null;

      let coOwners = [{
        userId: this.authenticationOfflineService.user.xSystemUserID,
        userFullName: this.authenticationOfflineService.user.displayName,
        indskr_procedurelogcoownerid: Guid.create().toString()
      }]

      if(copyDTO?.coVisitors?.length != 0){
        copyDTO.coVisitors = copyDTO.coVisitors.map(coVisitor => {
          return { ...coVisitor, indskr_procedurelogcovisitorid: Guid.create().toString() }
        });
      }

      if (autoSetOwnerAsCoowner) {
        copyDTO.coOwners = coOwners;
      } else {
        copyDTO.coOwners = [];
      }

      let newSurgeryOrder = new SurgeryOrderActivity(copyDTO);
      newSurgeryOrder.statusString = 'Draft';
      newSurgeryOrder.ownerId = this.authenticationOfflineService.user.systemUserID;
      newSurgeryOrder.ownerNameString = this.authenticationOfflineService.user.displayName;
      if(newSurgeryOrder.products && newSurgeryOrder.products.length != 0){
        newSurgeryOrder.products = newSurgeryOrder.products.map(p => {
          p.quantity = 1;
          return p;
        });
      }

      if(newSurgeryOrder.procedureNotes && newSurgeryOrder.procedureNotes.length != 0){
        newSurgeryOrder.procedureNotes = newSurgeryOrder.procedureNotes.map(p => {
          p.noteId = '';
          return p;
        });
      }

      if (masterSurgeryOrder.indskr_proceduresubtype) {
        newSurgeryOrder.indskr_proceduresubtypename = masterSurgeryOrder.indskr_proceduresubtypename
      }

      if (masterSurgeryOrder.indskr_proceduretype) {
        newSurgeryOrder.indskr_proceduretypename = masterSurgeryOrder.indskr_proceduretypename
      }

      if (masterSurgeryOrder.surveyResponseDTO) {
        newSurgeryOrder.surveyResponseDTO = masterSurgeryOrder.surveyResponseDTO;
      }

      await this.surgeryOrderActivityDataService.createOrderActivity({ onDynamics: !this.device.isOffline, onLocalCopy: true, onLocalDatabase: true }, [newSurgeryOrder], currentTime, false).then(succ => {
        this.trackingService.tracking('ProcedureLogCreate',TrackingEventNames.PROCEDURE_LOG);
        this.activityService.selectedActivity = newSurgeryOrder;
      }).catch(err => {
        errorOccured = true;
      });
      if (!errorOccured) {
        let from = PageName.GoAppHomeComponent;
        this.navService.setChildNavRoot(PageName.SurgeryOrderDetailsComponent, PageName.SurgeryOrderDetailsComponent, PageName.GoAppActivitiesPageComponent, { from: from, activity: newSurgeryOrder });
        this.uiService.activeView = 'ActivitiesPageRightPaneNav';
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        if (this.uiService.activitiesPageTab == 'day') {
          let data = {
            id: newSurgeryOrder.ID,
            subject: newSurgeryOrder.subject,
            location: (newSurgeryOrder.accountId) ? newSurgeryOrder.accountNameString : 'No Account',
            scheduledStart: newSurgeryOrder.scheduledStart,
            scheduledEnd: newSurgeryOrder.scheduledEnd,
            type: newSurgeryOrder.type,
          };
          this.uiService.setUIServiceData({
            view: 'new-activity', data,
          });
        }
        this.activityService.finalizeAgendaRefresh();
      }
      this.copySurgeryOrderActivityInProgress = false;
      this.uiService.dismissLoader();
    }
  }

  public async cloneSetBooking (masterSetBooking: SetBookingActivity){
    if(masterSetBooking && this.copySetBookingActivityInProgress == false){
      this.uiService.displayLoader();
      masterSetBooking = this.activityService.getActivityByID(masterSetBooking.ID) as SetBookingActivity;
      this.copySetBookingActivityInProgress = true;
      let start = this.dateTimeFormatService.toISOString(Utility.getRoundedDownTime(new Date()));
      let end = this.dateTimeFormatService.toISOString(this.dateTimeFormatService.addMinutesToDate(start, 30));
      let copyDTO ={
        "indskr_status": SetBookingStatus.DRAFT,
        "lookupfields": [],
        "indskr_type": masterSetBooking.rawData["indskr_type"],
        "indskr_operationtype": masterSetBooking.rawData["indskr_operationtype"],
        "indskr_operationsubtype": masterSetBooking.rawData["indskr_operationsubtype"],
        "indskr_surgerytype": masterSetBooking.rawData["indskr_surgerytype"],
        "indskr_source": 548910001,
        "indskr_operationstartdate": new Date(start).toISOString(),
        "indskr_operationenddate": new Date(end).toISOString(),
        "indskr_operationnote": masterSetBooking.rawData["indskr_operationnote"],
        "indskr_schedulecalendarevent": masterSetBooking.rawData["indskr_schedulecalendarevent"],
        "indskr_approch": masterSetBooking.rawData["indskr_approch"],
      }
      if(masterSetBooking.rawData["_indskr_accountnamesoldto_value"])
        copyDTO.lookupfields.push({
          "name": "indskr_accountnamesoldto",
          "entity": "accounts",
          "id": masterSetBooking.rawData["_indskr_accountnamesoldto_value"]
        });
      if(masterSetBooking.rawData["_indskr_surgeonaccountzsur_value"])
        copyDTO.lookupfields.push({
          "name": "indskr_surgeonaccountzsur",
          "entity": "accounts",
          "id": masterSetBooking.rawData["_indskr_surgeonaccountzsur_value"]
        });
      if(masterSetBooking.rawData["_indskr_surgeoncontact_value"])
        copyDTO.lookupfields.push({
          "name": "indskr_surgeoncontact",
          "entity": "contacts",
          "id": masterSetBooking.rawData["_indskr_surgeoncontact_value"]
      });
      if(masterSetBooking.rawData["_indskr_shipto_value"])
        copyDTO.lookupfields.push({
          "name": "indskr_shipto",
          "entity": "indskr_indskr_customeraddress_v2s",
          "id": masterSetBooking.rawData["_indskr_shipto_value"]
        });
      if(masterSetBooking.rawData["_indskr_partnerlocation_value"])
        copyDTO.lookupfields.push({
          "name": "indskr_partnerlocation",
          "entity": "indskr_indskr_customeraddress_v2s",
          "id": masterSetBooking.rawData["_indskr_partnerlocation_value"]
        });
      if(masterSetBooking.rawData["_indskr_salesconsultant_value"])
        copyDTO.lookupfields.push({
        "name": "indskr_salesconsultant",
        "entity": "systemusers",
        "id": masterSetBooking.rawData["_indskr_salesconsultant_value"]
      });

      let newSetBooking = new SetBookingActivity(copyDTO);
      newSetBooking.allDayEvent = !this.dateTimeFormatService.isSameDayCheck(newSetBooking.scheduledStart,newSetBooking.scheduledEnd);
      newSetBooking.serviceDTO = copyDTO;
      newSetBooking.statusString = 'Draft';

      const action:OperationDetail = {
        onDynamics: true,
        onLocalDatabase: true,
        onLocalCopy: true,
        operationDetail: {
          code: 'CREATENEWSETBOOKINGACTIVITY',
          message: 'Create New Set Booking Activity'
        }
      }
      await this.setBookingDataService.createSetBookingActivity(action,[newSetBooking],new Date().getTime()).then(async (res)=> {
        let setBookingProductsArray = await this.diskService.retrieve(DB_KEY_PREFIXES.SET_BOOKING_LINKED_ENTITY + "indskr_setbookingproduct");
        let linkEntityProductsData = setBookingProductsArray && (setBookingProductsArray.raw).filter(x => x["indskr_setbookingid"] == masterSetBooking.ID && (!x.hasOwnProperty('indskr_setbookingproduct.statecode') || (x.hasOwnProperty('indskr_setbookingproduct.statecode') && x['indskr_setbookingproduct.statecode'] == 0)));
        let teamMembersArray = await this.diskService.retrieve(DB_KEY_PREFIXES.SET_BOOKING_LINKED_ENTITY + "indskr_setbookingteammember");
        let linkEntityTeamMemData = teamMembersArray && (teamMembersArray.raw).filter(x=>x["indskr_setbookingid"] == masterSetBooking.ID && (!x.hasOwnProperty('indskr_setbookingproduct.statecode') || (x.hasOwnProperty('indskr_setbookingproduct.statecode') && x['indskr_setbookingproduct.statecode'] == 0)));
        
        let linkEntitiesReqPayload = [];
        linkEntityProductsData.forEach((product_obj)=>
          linkEntitiesReqPayload.push({
            "values": {
                "lookupfields": [
                    {
                        "name": "indskr_setBooking",
                        "entity": "indskr_setbookings",
                        "id": newSetBooking.ID
                    },
                    {
                        "name": "indskr_product",
                        "entity": "products",
                        "id": product_obj["indskr_setbookingproduct.indskr_product"]
                    }
                ],
                "indskr_quantity": product_obj["indskr_setbookingproduct.indskr_quantity"],
                "indskr_name": product_obj["indskr_setbookingproduct.indskr_name"]
            },
            "entity": "indskr_setbookingproducts",
          })
        );

        linkEntityTeamMemData.forEach((teamMemberObj)=>
          linkEntitiesReqPayload.push({
            "values": {
              "lookupfields": [
                  {
                      "name": "indskr_Setbooking",
                      "entity": "indskr_setbookings",
                      "id": newSetBooking.ID
                  },
                  {
                      "name": "indskr_member",
                      "entity": "systemusers",
                      "id": teamMemberObj["indskr_setbookingteammember.indskr_member"]
                  }
              ],
              "indskr_role": teamMemberObj["indskr_setbookingteammember.indskr_role"],
              "indskr_name": teamMemberObj["indskr_setbookingteammember.indskr_name"]
            },
            "entity": "indskr_setbookingteammembers",
          })  
        );

        if (linkEntitiesReqPayload && linkEntitiesReqPayload.length > 0) {
          for (let reqPayload of linkEntitiesReqPayload) {
            await this.dynamicFormService.createLinkedEntity(reqPayload.values, reqPayload.entity);
          }
          linkEntitiesReqPayload = [];
        }
        await this.setBookingDataService.fetchRealTimeSetBookingDetails(newSetBooking);
        if (this.uiService.activitiesPageTab == 'day') {
          let data = {
            id: newSetBooking.ID,
            subject: newSetBooking.subject,
            location: newSetBooking.statusString,
            scheduledStart: newSetBooking.scheduledStart,
            scheduledEnd: newSetBooking.scheduledEnd,
            type: newSetBooking.type,
          };
          this.uiService.setUIServiceData({
            view: 'new-activity', data,
          });
        }
        this.activityService.finalizeAgendaRefresh();
        if (this.agendaFooterService.actSegment === 'week') this.events.publish('weekview:RefreshUI');
        if(masterSetBooking) {       //if(data && data.eventsHandler)
          let rawDetails = {
            indskr_setbookingid: newSetBooking.ID,
          };
          if(rawDetails) {
            this.activityService.selected = newSetBooking;
          }
        }
        this.navService.setChildNavRoot(PageName.SetBookingActivityDetailsComponent, PageName.SetBookingActivityDetailsComponent, PageName.GoAppActivitiesPageComponent, { from: 'AgendaView', activity: this.activityService.selectedActivity, isCloneFlow: true});
        this.uiService.activeView = 'ActivitiesPageRightPaneNav';
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.uiService.dismissLoader();
      }).catch(err =>{
        console.error("Error in cloning kitbooking "  + err);
      });


      this.copySetBookingActivityInProgress = false;
      this.uiService.dismissLoader();
    }
  }

  async cloneActivity(activity: Activity) {
      switch (activity.type) {
      case ActivityType.Appointment:
        this.cloneAppointmentActivity(activity as AppointmentActivity);
        break;
      case ActivityType.PhoneCall:
        this.clonePhoneActivity(activity as PhoneActivity);
        break;
      case ActivityType.FollowUp:
        await this.cloneFollowupTask(activity as FollowUpActivity).then(success => {
        }).catch(error => {
        });
        return;
      case ActivityType.TimeOff:
        this.cloneTimeOff(activity as TimeOffActivity);
        break;
      case ActivityType.Email:
        this.cloneEmailActivity(activity as EmailActivity);
        break;
      case ActivityType.Order:
        await this.cloneOrderActivity(activity as OrderActivity).then(success => {
        }).catch(error => {
        });
        this.activityService.selectedActivityAtHome = this.activityService.selectedActivity;
        return;
      case ActivityType.CaseIntake:
        this.cloneCustomerInquiry(activity as CaseActivity);
        break;
      case ActivityType.SurgeryOrder:
        this.createSurgeryOrderCopy(activity as SurgeryOrderActivity);
        break;
      case ActivityType.ProcedureTracker:
        if (!this.device.isOffline) {
          this.cloneProcedureTracker(activity as ProcedureTrackerActivity);
        }
        break;
      case ActivityType.SetBooking:
        if (!this.device.isOffline) {
          this.cloneSetBooking(activity as SetBookingActivity)
        }
        break;
      case ActivityType.MedicalInquiry:
        void this.cloneMedicalInquiry(activity as MedicalInquiry);
        break;
    }

  }

  public async cloneMedicalInquiry(masterMi: MedicalInquiry): Promise<void> {
    if (!masterMi?.id || this.copyMedicalInquiryInProgress || !this.isMedicalInquiryEnabled) {
      return;
    }
    this.copyMedicalInquiryInProgress = true;
    this.uiService.displayLoader();
    try {
      const resolved = this.activityService.getActivityByID(masterMi.ID) as MedicalInquiry | undefined;
      const master = resolved ?? masterMi;
      const newMi = await this.medicalInquiryDataService.cloneMedicalInquiryFromMaster(master);
      await this.activityService.addActivity(newMi);
      this.medicalInquiryService.setSelectedMI(newMi);
      this.activityService.selectedActivity = newMi;
      this.activityService.publishActivityEvent({ action: 'Create', activity: newMi });
      if (this.uiService.activitiesPageTab === 'day') {
        this.uiService.setUIServiceData({
          view: 'new-activity',
          data: {
            id: newMi.ID,
            subject: newMi.displayTitle || this.translate.instant('MEDICAL_INQUIRY'),
            location: newMi.statusCodeFormatted || newMi.contactFormatted || '',
            scheduledStart: newMi.scheduledStart,
            scheduledEnd: newMi.scheduledEnd,
            type: newMi.type,
          },
        });
      }
      this.activityService.finalizeAgendaRefresh();
      if (this.agendaFooterService.actSegment === 'week') {
        this.events.publish('weekview:RefreshUI');
      }
      this.medicalInquiryService.agendaCloneOpenEditAfterDisplay = true;
      this.navService.setChildNavRoot(
        MedicalInquiryDetailComponent,
        PageName.MedicalInquiryDetailComponent,
        PageName.GoAppActivitiesPageComponent,
        { from: 'AgendaView', activity: newMi, isCloneFlow: true }
      );
      this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      this.uiService.showNewActivity = false;
      this.uiService.showRightPane = true;
    } catch (err) {
      console.error('ActivitiesPaneComponent: cloneMedicalInquiry failed', err);
      this.notificationService.notify(
        this.translate.instant('FAILED'),
        'ActivitiesPane',
        'top',
        ToastStyle.DANGER,
        3000
      );
    } finally {
      this.copyMedicalInquiryInProgress = false;
      this.uiService.dismissLoader();
    }
  }

  private async cloneFollowupTask(followupActivity : FollowUpActivity): Promise<any> {
    this.uiService.displayLoader();
    return new Promise(async (resolve, reject) => {
      let currentTime = new Date().getTime();
      let payload = {
        activityId: 'offline_followup_' + currentTime,
        activitytypecode: 'followuptask',
        subject: followupActivity.subject,
        offlineId: 'offline_followup_' + currentTime,
        indskr_plantype: followupActivity.planType,
      };
      let diffDays = this.dateTimeFormatService.getDifferenceInCalendarDays(new Date(), followupActivity.scheduledStart);
      if(diffDays <= 0) {
        payload['scheduledstart'] = followupActivity.scheduledStart;
      } else {
        payload['scheduledstart'] = currentTime;
      }
      payload['indskr_followupactiontype'] = followupActivity.followupActionTypeID ? followupActivity.followupActionTypeID : '';
      payload['indskr_followupactiontypename'] = followupActivity.followupActionTypeName ? followupActivity.followupActionTypeName : '';

      payload['indskr_priority'] = followupActivity.priorityID ? followupActivity.priorityID : '';
      payload['priorityValue'] = followupActivity.priorityValue ? followupActivity.priorityValue : '';

      if(followupActivity.accountId) {
        let account = this.accountOfflineService.getAccountById(followupActivity.accountId);
        if(!(!account || account.status === 2 || account.status == 548910003 || account.status == 548910010 || account.status == 548910011 || account.status == 548910012 || account.status == 548910013)){
          payload['indskr_account'] = followupActivity.accountId ? followupActivity.accountId : '';
          payload['accountName'] = followupActivity.accountNameString ? followupActivity.accountNameString : '';
        }
      }
      if(followupActivity.accountPlanId) {
        let accountPlan = this.accountManagementService.getAccountPlanByPlanId(followupActivity.accountPlanId);
        if(accountPlan && accountPlan.status.toLowerCase().includes('open')) {
          payload['indskr_accountplan'] = followupActivity.accountPlanId ? followupActivity.accountPlanId : '';
          payload['accountplanName'] = followupActivity.accountPlanNameString ? followupActivity.accountPlanNameString : '';
        }
      }

      payload['indskr_scientificplan'] = followupActivity.scientificPlanId ? followupActivity.scientificPlanId : '';
      payload['scientifiPlanName'] = followupActivity.scientificPlanNameString ? followupActivity.scientificPlanNameString : '';

      payload['opportunityid'] = followupActivity.opportunityId ? followupActivity.opportunityId : '';
      payload['opportunityName'] = followupActivity.opportunityIdNameString ? followupActivity.opportunityIdNameString : '';

      if(followupActivity.contactId) {
        let contact = this.contactService.getContactByID(followupActivity.contactId);
        if(contact && contact.isActive){
          payload['indskr_contact'] = followupActivity.contactId ? followupActivity.contactId : '';
          payload['contactName'] = followupActivity.contactNameString ? followupActivity.contactNameString : '';
        }
      }

      if(!this.device.isOffline && followupActivity.assignedTo && followupActivity.assignedTo.length > 0) {
        let users = [];
        let userData = []
        await this.followUpActivityDataService.getSameLevelAndChildUsersListOnline(false, true).then(async res => {
          userData = res;
        });
        followupActivity.assignedTo.forEach(user => {
          if(userData && userData.length > 0 && userData.some(systemUser => systemUser.systemuserid == user.userId)) {
            users.push({
              indskr_taskassignmentid: user.taskAssignmentId ? user.taskAssignmentId : '',
              activityid: user.activityId ? user.activityId : '',
              indskr_user: user.userId ? user.userId : '',
              userName: user.userFullName ? user.userFullName : '',
              ownerId: user.ownerId ? user.ownerId : ''
            });
          }
        });
        payload['taskUsersList'] = users;
      }

      if(followupActivity.products && followupActivity.products.length > 0) {
        let products = [];
        followupActivity.products.forEach(product => {
          if(this.brandService.brands.some(brand => brand.ID == product.productID)) {
            products.push({
              productId: product.productID ? product.productID : '',
              productName: product.productName ? product.productName : '',
              indskr_taskproductid: product.taskProductID ? product.taskProductID : ''
            });
          }
        });
        payload['products'] = products;
      }

      let newFollowUp = new FollowUpActivity(payload);
      newFollowUp.state = 0;
      newFollowUp.statusString = 'Open';
      newFollowUp.ownerId = this.authenticationOfflineService.user.systemUserID;
      newFollowUp.ownerNameString = this.authenticationOfflineService.user.displayName;
      newFollowUp.pendingPushToDynamics = true;
      await this.followUpActivityDataService.createFollowUpActivity({ onDynamics: !this.device.isOffline, onLocalCopy: true, onLocalDatabase: true }, [newFollowUp], currentTime, false).then(succ => {
        this.activityService.selectedActivity = newFollowUp;
      }).catch(err => {
        reject('Error occured while creating Scientific Activity Plan');

      });
      this.openActivityDetails(newFollowUp);
      this.uiService.dismissLoader();
    });
  }

  public async cloneCustomerInquiry (caseActivity: CaseActivity){
    this.uiService.displayLoader();
    let currentDate = new Date();
    let temp_id = "offline_case_" + Math.floor(currentDate.getTime() + Math.random() * 900000);

    let raw: any = {
      "productid_value": caseActivity._case_product_id,
      "statecode@OData.Community.Display.V1.FormattedValue": "Active",
      "statecode": 0,
      "statuscode@OData.Community.Display.V1.FormattedValue": "Open",
      'indskr_omnipresencestage_value@OData.Community.Display.V1.FormattedValue': 'Open',
      "statuscode": 0,
      "indskr_expertcategory_value": caseActivity._case_type_id,
      "indskr_expertcategory": caseActivity._case_type,
      "createdon": currentDate.getTime(),
      "indskr_intakecreated": currentDate.getTime(),
      "incidentid": temp_id,
      'indskr_externalid': temp_id,
      "ticketnumber": undefined,
      "indskr_responsepreference": caseActivity._case_response_preference_id,
      'ownerid_value': this.authenticationOfflineService.user.systemUserID,
      'ownerid_value@OData.Community.Display.V1.FormattedValue': this.authenticationOfflineService.user.displayName ? this.authenticationOfflineService.user.displayName : "",
      "isNew": true,
      "indskr_meeting_value": caseActivity._online_meetingID,
      "createdby_value": this.authenticationOfflineService.user.systemUserID
    }
    if(caseActivity._case_account_id) {
      let account = this.accountOfflineService.getAccountById(caseActivity._case_account_id);
        if(!(!account || account.status === 2 || account.status == 548910003 || account.status == 548910010 || account.status == 548910011 || account.status == 548910012 || account.status == 548910013)){
          raw['indskr_account_value'] = caseActivity._case_account_id ? caseActivity._case_account_id : undefined;
          raw['indskr_account_value@OData.Community.Display.V1.FormattedValue'] = caseActivity._case_trans_account_name ? caseActivity._case_trans_account_name : undefined;
        }
    }

    if(caseActivity._case_contact_id) {
      let contact = this.contactService.getContactByID(caseActivity._case_contact_id);
      if(contact && contact.isActive){
        raw['customerid_value'] = caseActivity._case_contact_id ? caseActivity._case_contact_id : undefined;
        raw['customerid_value@OData.Community.Display.V1.FormattedValue'] = caseActivity._case_trans_customer_name ? caseActivity._case_trans_customer_name : undefined;
      }
    }
    if(caseActivity._selected_address) {
      raw['indskr_customeraddress'] = caseActivity._selected_address;
    }
    if(caseActivity._selected_email_id) {
      raw['indskr_customeremail'] = caseActivity._selected_email_id;
    }
    if(caseActivity._selected_phone) {
      raw['indskr_customerphone'] = caseActivity._selected_phone;
    }
    let iCase = new CaseActivity(raw);
    iCase._case_response_preference = caseActivity._case_response_preference;
    iCase._id = DB_KEY_PREFIXES.MY_CASES + iCase.ID;

    this.caseManagementService.assignSelectedCase(iCase);
    await this.diskService.addCaseToCollection(iCase);
    this.caseManagementService.upsertMyCases(iCase);
    this.events.publish("refreshAgenda");
    this.openActivityDetails(iCase);
    this.uiService.dismissLoader();
  }

  private async cloneOrderActivity(orderActivity : OrderActivity): Promise<any> {
    this.uiService.displayLoader();
    return new Promise(async (resolve, reject) => {
      let currentTime = new Date().getTime();
      let start, end;
      start = this.dateTimeFormatService.toISOString(Utility.getRoundedDownTime(new Date()));
      end = this.dateTimeFormatService.toISOString(this.dateTimeFormatService.addMinutesToDate(start, 30));
      let payload = {
        salesorderid: 'offline_order_' + currentTime,
        indskr_externalid: 'offline_order_' + currentTime,
        indskr_ordertype:548910000,
        ordernumber: 'New Order',
        subject: 'New Order',
        name: 'New Order',
        pendingPushToDynamics: true,
        statuscode: 1,
        statecode: 0,
        activitytypecode: 'indskr_order',
        createdon: new Date(currentTime).getTime(),
        scheduledstart: new Date(start).getTime(),
        scheduledend: new Date(end).getTime(),
      }
      if(orderActivity.accountId) {
        let account = this.accountOfflineService.getAccountById(orderActivity.accountId);
        if(!(!account || account.status === 2 || account.status == 548910003 || account.status == 548910010 || account.status == 548910011 || account.status == 548910012 || account.status == 548910013)){
          payload['customerid'] = orderActivity.accountId || '';
          payload['customerName'] = orderActivity.accountNameString || '';
          if(orderActivity.opportunityId) {
            let opportunity = this.opportunitiesService.getOpportunityDetailsbyId(orderActivity.opportunityId);
            if(opportunity && opportunity.stateCode === 0) {
              payload['opportunityid'] = orderActivity.opportunityId || '';
              payload['opportunityName'] = orderActivity.opportunityNameString || '';
            }
          }
          if(orderActivity.accountPlanId) {
            let accountPlan = this.accountManagementService.getAccountPlanByPlanId(orderActivity.accountPlanId);
            if(accountPlan && accountPlan.status.toLowerCase().includes('open')) {
              payload['accountplanid'] = orderActivity.accountPlanId || '';
              payload['accountplanName'] = orderActivity.accountPlanNameString || '';
            }
          }
        }
      }
      payload['indskr_country'] = orderActivity.countryId || '';
      payload['countryName'] = orderActivity.countryNameString || '';
      payload['discountpercentage'] = orderActivity.elligibleDiscount || '';
      if(orderActivity.priceListId && this.orderManagementService.priceLists) {
        let priceList = this.orderManagementService.priceLists.find(p => p.ID === orderActivity.priceListId);
        if(priceList) {
          payload['pricelevelid'] = orderActivity.priceListId || '';
          payload['totalamount'] = orderActivity.total || '';
          payload['formattedTotalAmount'] = orderActivity.formattedTotalAmount || '';
          if(orderActivity.products && orderActivity.products.length > 0) {
            let products = [];
            orderActivity.products.forEach(product => {
              products.push({
                productid: product.productId,
                productName: product.productName ? product.productName : '',
                extendedamount: product.total ? product.total : 0,
                formattedExtendedamount: product.formattedTotal ? product.formattedTotal : '',
                priceperunit: product.unitPrice ? product.unitPrice : 0,
                quantity: product.quantity ? product.quantity : 0,
                uomid: product.uomid ? product.uomid : '',
                isDeleted: product.isDeleted ? product.isDeleted : '',
              });
            });
            payload['products'] = products;
          }
        }
      }

      let newOrder = new OrderActivity(payload);
      newOrder.statusString = 'Open';
      newOrder.ownerId = this.authenticationOfflineService.user.systemUserID;
      newOrder.ownerNameString = this.authenticationOfflineService.user.displayName;

      await this.orderActivityDataService.createOrderActivity({ onDynamics: !this.device.isOffline, onLocalCopy: true, onLocalDatabase: true }, [newOrder], currentTime, false).then(succ => {
        this.trackingService.tracking('OrderCreate',TrackingEventNames.ORDER);
        this.activityService.selectedActivity = newOrder;
      }).catch(err => {
        reject('error occured while creating new order');
      });
      this.openActivityDetails(newOrder);
      this.uiService.dismissLoader();
    });
  }

  public async cloneTimeOff (masterTimeOffActivity: TimeOffActivity){
    this.uiService.displayLoader();
    let currentDate = new Date();
    if(masterTimeOffActivity.durationType == DurationType.AllDay) {
      this.newTimeOff.totStartTime = new Date(currentDate.setHours(0, 0, 0));
      this.newTimeOff.totEndTime = new Date(currentDate.setHours(23, 59, 59));
    } else if(masterTimeOffActivity.durationType == DurationType.HalfDay) {
      let meridian = this.dateTimeFormatService.formatDate(new Date, 'A');
        if (meridian === 'PM') {
          this.timeOffService.popupSelectedTimePeriodEvent = "PM";
          this.newTimeOff.totStartTime = new Date(currentDate.setHours(12, 0, 0));
          this.newTimeOff.totEndTime = new Date(currentDate.setHours(23, 59, 59));
        } else {
          this.timeOffService.popupSelectedTimePeriodEvent = "AM";
          this.newTimeOff.totStartTime = new Date(currentDate.setHours(0, 0, 0));
          this.newTimeOff.totEndTime = new Date(currentDate.setHours(11, 59, 59));
        }
    } else if(masterTimeOffActivity.durationType == DurationType.Hourly) {
        this.newTimeOff.totStartTime = new Date(currentDate.setHours(8,0,0)); // default start time value
        let setCombinedDateTimeForEndTime = this.dateTimeFormatService.toISOString(this.dateTimeFormatService.addMinutesToDate(this.newTimeOff.totStartTime, 60));
        this.newTimeOff.totEndTime = new Date(setCombinedDateTimeForEndTime);
        this.events.publish("initTimePickerLimitedMinTime", {startDateTime: this.newTimeOff.totStartTime, endDateTime: this.newTimeOff.totEndTime});
    }
    this.newTimeOff.scheduledStartLocale = this.newTimeOff.totStartTime.toLocaleTimeString('en-US', { hour12: true, hour: '2-digit', minute: '2-digit' });
    this.newTimeOff.offlineTimeOffRequestId = "offline_tot_" + currentDate.getTime();
    this.newTimeOff.totIsAlldayEvent = masterTimeOffActivity.totIsAlldayEvent;
    this.newTimeOff.timeOffReason = masterTimeOffActivity.timeOffReason;
    this.newTimeOff.reason = masterTimeOffActivity.reason;
    if(this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.TIME_OFF_AUTOSUBJECT)) {
      this.newTimeOff.name = masterTimeOffActivity.reason + ` - ${this.translate.instant('TIME_OFF')}`
      this.newTimeOff.subject = masterTimeOffActivity.reason + ` - ${this.translate.instant('TIME_OFF')}`
    } else {
      this.newTimeOff.name = masterTimeOffActivity.name;
      this.newTimeOff.subject = masterTimeOffActivity.subject;
    }
    this.newTimeOff.durationType = masterTimeOffActivity.durationType;
    this.newTimeOff.state = 0;
    this.newTimeOff.statecode = 0;
    this.newTimeOff.status = 100000000;
    this.newTimeOff.statusString = 'Open';
    this.newTimeOff.statusValue = 'Open';
    this.newTimeOff.type = ActivityType.TimeOffRequest;
    this.newTimeOff.scheduledStart = this.newTimeOff.totStartTime;
    this.newTimeOff.scheduledEnd = this.newTimeOff.totEndTime;
    this.newTimeOff.positionId = this.authenticationOfflineService.user.xPositionID;
    this.newTimeOff.totOwnerId = this.authenticationOfflineService.user.systemUserID;

    this.timeOffService.display = true;


    if (this.device.isOffline) {
      await this.timeOffService.saveMyTimeOff(this.newTimeOff, false).then(() => {
        if (this.navService.getCurrentPageName() === PageName.GoAppActivitiesPageComponent) {
          this.navService.setChildNavRoot(PageName.TimeOffDetailsComponent, PageName.TimeOffDetailsComponent, PageName.GoAppActivitiesPageComponent, { isNewlyCreatedActivity: true });
          this.footerService.initButtons(FooterViews.TimeOffDetails);
        }
      });
    }
    else if (!this.device.isOffline) {
      this.timeOffDataService.createNewTimeOff(this.newTimeOff).subscribe(
        async (success: any) => {
          await this.timeOffService.saveMyTimeOff(this.newTimeOff, true, success).then(() => {
            if (this.navService.getCurrentPageName() === PageName.GoAppActivitiesPageComponent) {
              this.navService.setChildNavRoot(PageName.TimeOffDetailsComponent, PageName.TimeOffDetailsComponent, PageName.GoAppActivitiesPageComponent, { isNewlyCreatedActivity: true });
              this.footerService.initButtons(FooterViews.TimeOffDetails);
            }
          });
        },
        async error => {
          await this.timeOffService.saveMyTimeOff(this.newTimeOff, false).then(() => {
            if (this.navService.getCurrentPageName() === PageName.GoAppActivitiesPageComponent) {
              this.navService.setChildNavRoot(PageName.TimeOffDetailsComponent, PageName.TimeOffDetailsComponent, PageName.GoAppActivitiesPageComponent, { isNewlyCreatedActivity: true });
              this.footerService.initButtons(FooterViews.TimeOffDetails);
            }
          })
        });
    }
    this.openActivityDetails(this.newTimeOff);
    this.uiService.dismissLoader();

  }

  private async cloneAppointmentActivity(activity: AppointmentActivity) {
    try {
      this.uiService.displayLoader();
      
      await this.prepareActivityData(activity);
      
      const newMeeting = await this.createNewMeetingFromActivity(activity);
      if (!newMeeting) {
        this.uiService.dismissLoader();
        return;
      }
      
      // Clear GPS check-in details immediately to prevent inheritance (OMNI-57412)
      // This ensures cloned meetings don't inherit parent's GPS record ID
      newMeeting.gpsCheckInDetails = {};
      newMeeting.isClone = true;
      
      this.setupNewActivityUI(newMeeting);
      
      await this.cloneActivityEntities(activity, newMeeting);
      
      await this.cloneActivityProducts(activity, newMeeting);
      
      await this.cloneMeetingNotes(activity, newMeeting);
      
      await this.handleLegacyNotes(activity, newMeeting);
      
      await this.finalizeClonedActivity(newMeeting);
      
    } catch (error) {
      console.error('Error cloning appointment activity:', error);
    } finally {
      this.uiService.dismissLoader();
    }
  }

  private async prepareActivityData(activity: AppointmentActivity): Promise<void> {
    if (!(this.activityService.hasOfflineMeetingData(activity.ID) || activity.ID.includes('offline_'))) {
      const activityDoc = await this.activityDataService.getOfflineActivityDocByKey(
        DB_KEY_PREFIXES.MEETING_ACTIVITY + activity.ID
      );
      if (activityDoc) {
        await this.activityDataService._appendMeetingDetailsToActivity(activity, activityDoc);
      }
    }
  }

  private async createNewMeetingFromActivity(activity: AppointmentActivity): Promise<AppointmentActivity | null> {
    const { start, end } = this.calculateMeetingTimes(activity);
    
    const payload = new InitiateMeetingPayload(
      activity.subject,
      activity.location,
      new Date(start).getTime(),
      new Date(end).getTime(),
      '',
      this.activityService.generateOfflineMeetingId(),
      undefined,
      undefined,
      undefined,
      activity.indskr_activitytype,
      activity.activityTypeName,
      activity.indskr_activitysubtype,
      activity.activitySubTypeName
    );
    
    return await this.meetingService.createNewMeeting(payload, null, true);
  }

  private calculateMeetingTimes(activity: AppointmentActivity): { start: string; end: string } {
    const cloneMeetingWithDateTimeNotesProductValuesFlag = this.authenticationOfflineService.hasIoConfigWithFeatureCode(
      IoConfigurationFeatureCodes.CLONE_MEETING_WITH_DATE_TIME_NOTES_PRODUCT_VALUES
    );
    
    const diffDays = this.dateTimeFormatService.getDifferenceInCalendarDays(new Date(), activity.scheduledStart);
    const canUseOriginalTimes = activity.scheduledStart && activity.scheduledEnd &&
      diffDays <= this.authenticationOfflineService.user.maxMeetingStartDays &&
      cloneMeetingWithDateTimeNotesProductValuesFlag;

    if (canUseOriginalTimes) {
      return {
        start: this.dateTimeFormatService.toISOString(new Date(activity.scheduledStart)),
        end: this.dateTimeFormatService.toISOString(new Date(activity.scheduledEnd))
      };
    } else {
      const start = this.dateTimeFormatService.toISOString(this.getRoundedTime(new Date()));
      const end = this.dateTimeFormatService.toISOString(this.dateTimeFormatService.addMinutesToDate(start, this.authenticationOfflineService.user?.meeting_duration || 30));
      return { start, end };
    }
  }

  private setupNewActivityUI(newMeeting: AppointmentActivity): void {
    const data = this.createUIServiceData(newMeeting);
    this.uiService.setUIServiceData({
      view: 'new-activity',
      data,
    });
    this.activityService.selectedActivity = newMeeting;
  }

  private createUIServiceData(newMeeting: AppointmentActivity): any {
    if (!newMeeting.createdOffline) {
      return { id: newMeeting.ID };
    } else {
      return {
        id: newMeeting.ID,
        subject: newMeeting.subject,
        location: newMeeting.location,
        scheduledStart: newMeeting.scheduledStart,
        scheduledEnd: newMeeting.scheduledEnd,
      };
    }
  }

  private async cloneActivityEntities(activity: AppointmentActivity, newMeeting: AppointmentActivity): Promise<void> {
    await Promise.all([
      this.cloneAccounts(activity, newMeeting),
      this.cloneContacts(activity, newMeeting),
      this.cloneAccompaniedUsers(activity, newMeeting),
      this.clonePresentations(activity, newMeeting),
      this.cloneOpportunities(activity, newMeeting),
      this.cloneCoachingPlan(activity, newMeeting)
    ]);
  }

  private async cloneAccounts(activity: AppointmentActivity, newMeeting: AppointmentActivity): Promise<void> {
    if (!activity.accounts?.length) return;
    
    newMeeting['accounts'] = [];
    const validAccounts = activity.accounts.filter(activityAccount => {
      const account = this.accountOfflineService.getAccountById(activityAccount.id);
      return account && !this.isAccountInactive(account);
    });
    
    validAccounts.forEach(activityAccount => {
      const account = this.accountOfflineService.getAccountById(activityAccount.id);
      this.accountOfflineService.moveAccountToSelected(account);
    });
    
    if (this.shouldUpdateOnline(newMeeting)) {
      await this.meetingService.addAccountsToMeeting(newMeeting);
    }
  }

  private isAccountInactive(account: any): boolean {
    const inactiveStatuses = [2, 548910003, 548910010, 548910011, 548910012, 548910013];
    return !account || account.status === 2 || inactiveStatuses.includes(account.status);
  }

  private async cloneContacts(activity: AppointmentActivity, newMeeting: AppointmentActivity): Promise<void> {
    if (!activity.contacts?.length) return;
    
    newMeeting['contacts'] = [];
    const validContacts = activity.contacts.filter(activityContact => {
      const contact = this.contactService.getContactByID(activityContact.ID);
      return contact?.isActive;
    });
    
    validContacts.forEach(activityContact => {
      const contact = this.contactService.getContactByID(activityContact.ID);
      newMeeting['contacts'].push(contact);
    });
    
    if (this.shouldUpdateOnline(newMeeting)) {
      await this.meetingService.addContactsToMeeting(newMeeting, true);
      // Reset GPS check-in details to ensure cloned meeting gets fresh GPS data (OMNI-57412)
      // This prevents the cloned meeting from inheriting parent's GPS record ID
      newMeeting.gpsCheckInDetails = {};
      newMeeting.isClone = true;
      // Trigger GPS capture when contacts are cloned
      await this.meetingLocationCaptureService.captureContactLocationDistance(newMeeting);
    }
  }

  private async cloneAccompaniedUsers(activity: AppointmentActivity, newMeeting: AppointmentActivity): Promise<void> {
    if (!activity.accompaniedUserList?.length) return;
    
    newMeeting['accompaniedUserList'] = [...activity.accompaniedUserList];
    
    if (this.shouldUpdateOnline(newMeeting)) {
      await this.meetingService.addRemoveAccompaniedUsers(newMeeting['accompaniedUserList']);
    }
  }

  private async clonePresentations(activity: AppointmentActivity, newMeeting: AppointmentActivity): Promise<void> {
    if (!activity.presentations?.length) return;
    
    newMeeting['presentations'] = [];
    const validPresentations = activity.presentations.filter(activityPresentation => {
      const foundPres = this.findPresentation(activityPresentation);
      return foundPres && Utility.filterByDate(foundPres);
    });
    
    validPresentations.forEach(activityPresentation => {
      newMeeting['presentations'].push(activityPresentation);
    });
    
    if (this.shouldUpdateOnline(newMeeting)) {
      try {
        await this.meetingService.addContentToMeeting(newMeeting.presentations, newMeeting);
      } catch (error) {
        this.notificationService.notify(
          this.translate.instant('ERROR_UPDATING_MEETING_PRESENTATIONS'),
          'New Activity'
        );
      }
    }
  }

  private findPresentation(activityPresentation: any): any {
    if (activityPresentation instanceof Presentation) {
      return this.presentationService.presentation.find(p => 
        p.ioPresentationId === activityPresentation.contentId || 
        p.contentId === activityPresentation.contentId
      );
    } else if (activityPresentation instanceof Resource) {
      return this.resourceService.allResources.find(p => 
        p.contentId === activityPresentation.contentId
      );
    }
    return null;
  }

  private async cloneOpportunities(activity: AppointmentActivity, newMeeting: AppointmentActivity): Promise<void> {
    if (!activity.associatedOpportunities?.length) return;
    
    newMeeting['associatedOpportunities'] = [];
    const payload: string[] = [];
    
    activity.associatedOpportunities.forEach(activityOpportunity => {
      const opportunity = this.opportunitiesService.getOpportunityDetailsbyId(activityOpportunity.opportunityId);
      if (opportunity && opportunity.statusCode !== 548910000) {
        (newMeeting as AppointmentActivity).associatedOpportunities.push({
          opportunityId: opportunity.ID,
          opportunityName: opportunity.opportunityName,
        });
        payload.push(opportunity.ID);
      }
    });
    
    if (this.shouldUpdateOnline(newMeeting)) {
      await this.meetingService.addOpportunitiesToMeeting(newMeeting, payload);
    }
  }

  private async cloneCoachingPlan(activity: AppointmentActivity, newMeeting: AppointmentActivity): Promise<void> {
    if (!activity.indskr_coachingplan || !activity.indskr_coachingplanname) return;
    
    newMeeting['indskr_coachingplan'] = activity.indskr_coachingplan;
    newMeeting['indskr_coachingplanname'] = activity.indskr_coachingplanname;
    
    if (this.shouldUpdateOnline(newMeeting)) {
      await this.meetingService.updateMeetingCoachingPlanOnline(
        { indskr_coachingplan: activity.indskr_coachingplan },
        newMeeting.ID
      );
    }
  }

  private async cloneActivityProducts(activity: AppointmentActivity, newMeeting: AppointmentActivity): Promise<void> {
    const cloneMeetingWithDateTimeNotesProductValuesFlag = this.authenticationOfflineService.hasIoConfigWithFeatureCode(
      IoConfigurationFeatureCodes.CLONE_MEETING_WITH_DATE_TIME_NOTES_PRODUCT_VALUES
    );
    
    if (!activity.products?.length || !cloneMeetingWithDateTimeNotesProductValuesFlag) return;
    
    const clonedProducts = this.filterAndCloneProducts(activity, newMeeting);
    
    if (clonedProducts.length > 0) {
      newMeeting.products = clonedProducts;
      
      if (this.shouldUpdateOnline(newMeeting)) {
        await this.meetingService.updateMeetingProductKeyMessages(newMeeting as AppointmentActivity);
        this.events.publish('user:activity_products_created', newMeeting.products);
      }
    }
  }

  private filterAndCloneProducts(activity: AppointmentActivity, newMeeting: AppointmentActivity): any[] {
    const isCovisitor = this.isUserCovisitor(activity);
    const isNotOwner = activity.meetingOwnerId !== this.authenticationOfflineService.user.systemUserID;
    
    const clonedProducts = cloneDeep(activity.products);
    const selectedProducts = clonedProducts.filter(product => 
      (product.isSelected || product.isAutoSelected) &&
      product["productStructure"] !== 3 &&
      !product["isCompetitor"]
    );
    
    if (isCovisitor && isNotOwner) {
      return selectedProducts.filter(product => 
        this.brandService.brands.some(brand => brand.ID === product.ID)
      );
    }
    
    return selectedProducts;
  }

  private isUserCovisitor(activity: AppointmentActivity): boolean {
    return activity.accompaniedUserList?.some(user => 
      user.id === this.authenticationOfflineService.user.systemUserID
    ) || false;
  }

  private async cloneMeetingNotes(activity: AppointmentActivity, newMeeting: AppointmentActivity): Promise<void> {
    const cloneMeetingWithDateTimeNotesProductValuesFlag = this.authenticationOfflineService.hasIoConfigWithFeatureCode(
      IoConfigurationFeatureCodes.CLONE_MEETING_WITH_DATE_TIME_NOTES_PRODUCT_VALUES
    );
    
    if (!cloneMeetingWithDateTimeNotesProductValuesFlag || !activity.meetingNotes?.length) return;
    
    const notesToClone = activity.meetingNotes.filter(note => 
      !note.isDeleted && note.noteText?.trim().length > 0
    );
    
    if (notesToClone.length === 0) return;
    
    const clonedNotes = this.createClonedNotes(notesToClone, newMeeting.ID);
    newMeeting.meetingNotes = clonedNotes;
    
    await this.saveClonedNotes(clonedNotes, newMeeting);
  }

  private createClonedNotes(notesToClone: any[], activityId: string): any[] {
    const now = new Date().getTime().toString();
    
    return notesToClone.map(note => {
      const notePayload = {
        annotationid: 'offlinmeetingnote' + now + Math.random().toString(36).substring(7),
        activityid: activityId,
        createdon: now,
        notetext: note.noteText,
        ownerName: this.authenticationOfflineService.user.displayName,
        ownerid: this.authenticationOfflineService.user.systemUserID,
        deleted: false,
        pendingPushForDynamics: true,
        isdocument: false,
      };
      
      return new IONote(notePayload);
    });
  }

  private async saveClonedNotes(clonedNotes: any[], newMeeting: AppointmentActivity): Promise<void> {
    const now = new Date().getTime().toString();
    
    for (const note of clonedNotes) {
      const payload = {
        annotationid: note.noteId,
        activityid: note.activityId,
        createdon: now,
        notetext: note.noteText,
        ownerName: note.ownerName,
        ownerid: note.ownerId,
        deleted: note.isDeleted,
        pendingPushForDynamics: note.pendingPushForDynamics,
        isdocument: note.hasDocument
      };
      await this.activityService.updateMeetingNoteInOfflineDB(payload);
    }
    
    if (this.shouldUpdateOnline(newMeeting)) {
      await this.meetingService.uploadMeetingNotesOnline();
    }
  }

  private async handleLegacyNotes(activity: AppointmentActivity, newMeeting: AppointmentActivity): Promise<void> {
    if (!activity.notes?.trim().length) return;
    
    newMeeting.notes = activity.notes;
    
    if (this.shouldUpdateOnline(newMeeting)) {
      const payload = new UpdateMeetingPayload(
        newMeeting.subject,
        newMeeting.location,
        newMeeting.scheduledStart,
        newMeeting.scheduledEnd,
        newMeeting.notes
      );
      payload.notes = newMeeting.notes;
      
      await this.meetingService.updateMeeting(newMeeting, payload);
    }
  }

  private async finalizeClonedActivity(newMeeting: AppointmentActivity): Promise<void> {
    if (newMeeting instanceof AppointmentActivity) {
      // Re-derive the secondary-info subject now that accounts/contacts/products are
      // attached - createNewMeeting built it against an empty shell, dropping the
      // account/contact segments (OMNI-60713).
      await this.meetingService.recomputeSecInfoSubjectAfterAttach(newMeeting);
      await this.activityService.upsertMeetingsOfflineData(newMeeting);
      this.openActivityDetails(newMeeting);
    }
  }

  private shouldUpdateOnline(activity: AppointmentActivity): boolean {
    return !this.device.isOffline && !this.activityService.hasOfflineMeetingData(activity.ID);
  }

  private async clonePhoneActivity(activity:PhoneActivity){
    try {
      this.uiService.displayLoader();
      if(!(this.activityService.hasOfflinePhoneCallData(activity.ID) || activity.ID.includes('offline_'))){
        const activityDoc = await this.activityDataService.getOfflineActivityDocByKey(DB_KEY_PREFIXES.PHONE_CALL_ACTIVITY+activity.ID);
        if(activityDoc){
          await this.activityDataService._appendPhoneCallDetailsToActivity(activity, activityDoc);
        }
      }

      let currentTime = new Date().getTime();
      let start, end;
      start = this.dateTimeFormatService.toISOString(Utility.getRoundedDownTime(new Date()));
      start = this.dateTimeFormatService.toISOString(this.dateTimeFormatService.addMinutesToDate(start, 30));
      end = this.dateTimeFormatService.toISOString(this.dateTimeFormatService.addMinutesToDate(start, 30));
      let payload = new InitiatePhoneCallPayload(
        new Date(start).getTime(),
        new Date(end).getTime(),
        activity.subject,
        OFFLINE_PHONE_CALL_ID_PREFIX + new Date().getTime(),
        0
      );

      let newPhoneCall = await this.phonecallDataService.createPhoneCallActivity(payload);
      if(newPhoneCall){
        let data;
        if (!newPhoneCall.createdOffline) {
          data = { id: newPhoneCall.ID };
        } else {
          data = {
            id: newPhoneCall.ID,
            subject: newPhoneCall.subject,
            location: newPhoneCall.location,
            scheduledStart: newPhoneCall.scheduledStart,
            scheduledEnd: newPhoneCall.scheduledEnd,
          };
        }
        this.uiService.setUIServiceData({
          view: 'new-activity', data,
        }); // this is an observable stream

        this.activityService.selectedActivity = newPhoneCall;

        if(activity.contacts && activity.contacts.length != 0){
          this.activityService.selectedActivity['contacts'] = [];
          newPhoneCall.selectedMobileNumber = activity.selectedMobileNumber
          const activityContact = activity.contacts[0];
          let contact = this.contactService.getContactByID(activityContact.ID);
          if(contact && contact.isActive){
            this.contactService.moveContactToSelected(contact);
            await this.phonecallDataService.addContactsToPhoneCallActivity(newPhoneCall);
          }
        }
        if(activity.accounts && activity.accounts.length != 0){
          this.activityService.selectedActivity['accounts'] = [];
          activity.accounts.forEach(activityAccount=> {
            let account = this.accountOfflineService.getAccountById(activityAccount.id);
            if(!(!account || account.status === 2 || account.status == 548910003 || account.status == 548910010 || account.status == 548910011 || account.status == 548910012 || account.status == 548910013)){
              this.accountOfflineService.moveAccountToSelected(account);
            }
          })
        }

        if (this.activityService.selectedActivity instanceof PhoneActivity) {
          this.phonecallDataService.saveMeeting(newPhoneCall);
          let phoneCallPayLoad = this.phonecallDataService.setPhoneCallPayload(this.activityService.selectedActivity as PhoneActivity)
          if (!this.device.isOffline && !this.activityService.hasOfflinePhoneCallData(this.activityService.selectedActivity.ID)) {
            await this.phonecallDataService.updatePhoneCall(this.activityService.selectedActivity as PhoneActivity, phoneCallPayLoad); //CWD-2414 Update the activity subject if auto subject feature action is enabled
          }
          else {
            await this.activityService.upsertPhoneCallOfflineData(this.activityService.selectedActivity as PhoneActivity);
          }
          this.openActivityDetails(this.activityService.selectedActivity);
        }
        this.uiService.dismissLoader();
      }
    } catch (error) {

    }
  }

  private async cloneEmailActivity(activity:EmailActivity){
    try {
      this.uiService.displayLoader();
      let scheduleTime = new Date().getTime().toString();
      let payload = {
        scheduledstart: scheduleTime,
        scheduledend: scheduleTime,
        subject: activity.subject,
        statuscode: 1,
        channelType: activity.channelType,
        channelId: activity.indskr_channelid,
        channelActivityType: activity.channelActivityType,
      };
      let newActivity:EmailActivity = await this.emailService.createNewEmailActivity(payload);
      if(this.navService.getCurrentMasterPageName() !== PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPagePlanTabSelectedPlan !== 'callPlans') this.uiService.activeView = 'Email';
      let data = {
        id: newActivity.ID, subject: newActivity.subject, info: newActivity.info, type: newActivity.type,
        scheduledStart: newActivity.scheduledStart, scheduledEnd: newActivity.scheduledEnd,
      };
      this.activityService.addActivity(newActivity);
      if (this.uiService.activitiesPageTab === 'day') {
        this.uiService.setUIServiceData({
          view: 'new-activity', data
        });
      }
      this.emailService.selectedActivity = newActivity;
      this.activityService.selectedActivity = newActivity;
      this.emailService.setCurrentEmail(this.emailService.selectedActivity);
      /*===*===*===*===*===*===*=== Email Account Information Capture ===*===*===*===*===*===*===*/
      if(this.emailService.selectedActivity && this.emailService.selectedActivity.accounts && this.emailService.selectedActivity.accounts.length != 0){
        this.emailService.selectedActivity['accounts'] = [];
        this.emailService.selectedActivity.accounts.forEach(activityAccount=> {
          let account = this.accountOfflineService.getAccountById(activityAccount.id);
          if(!(!account || account.status === 2 || account.status == 548910003 || account.status == 548910010 || account.status == 548910011 || account.status == 548910012 || account.status == 548910013)){
            this.accountOfflineService.moveAccountToSelected(account);
          }
        })
      }
      /*===*===*===*===*===*===*=== Email Account Information Capture ===*===*===*===*===*===*===*/
      if (!isEmpty(activity.emailActivityParties)) {
        let emailActivityParties: EmailActivityParty[] = [];
        let selectedContactsForNonNativeChannelSMS = false;
        if (newActivity.isMessageExternal && newActivity.channelActivityType == ChannelActivityType.SMS && newActivity?.isPreviewEnabled) {
          selectedContactsForNonNativeChannelSMS = true;
        }
        let amaNoContactSkipped = false;
        activity.emailActivityParties.forEach(emailContact => {
          const contact = this.contactService.getContactByID(emailContact.indskr_contactid);
          // OMNI-61541: AMA No-Contact — do not add a flagged (donotemail) contact; notify after the loop.
          if (contact && contact.donotemail === true) { amaNoContactSkipped = true; return; }
          if(contact && contact.isActive){
            let emailActivityParty: EmailActivityParty = new EmailActivityParty();
            emailActivityParty.contact_firstname = contact.firstName;
            emailActivityParty.contact_lastname = contact.lastName;
            emailActivityParty.indskr_contactid = contact.ID;
            emailActivityParty.contact_mobilephone = contact.mobilePhone;
            emailActivityParty.contact_indskr_facebookpsid = contact.indskr_facebookpsid;
            emailActivityParty.emailAddresses = [];
            contact.emailAddressList.forEach(emailAddress => {
              if (emailContact.emailAddresses && emailContact.emailAddresses.some(e=> e.emailAddress == emailAddress.emailAddress)) {
                let emailAddressDetails: EmailAddress = new EmailAddress();
                emailAddressDetails.email_addressid = emailAddress.emailAddressId;
                emailAddressDetails.emailAddress = emailAddress.emailAddress
                emailActivityParty.emailAddresses.push(emailAddressDetails);
              }
            });
            if (selectedContactsForNonNativeChannelSMS) {
              emailActivityParty.contact_mobilephone = emailContact.contact_mobilephone;
            }
            // OMNI-61541: propagate donotemail unconditionally (AMA No-Contact send-block is
            // independent of MESSAGE_CONSENT_REQUIRED).
            if (contact.hasOwnProperty('donotemail') && contact.donotemail !== undefined) {
              emailActivityParty.donotemail = contact.donotemail;
            }
            emailActivityParties.push(emailActivityParty);
          }
        });
        // OMNI-61541: inform the user that AMA No-Contact contacts were not added.
        if (amaNoContactSkipped) {
          this.notificationService.notify(this.translate.instant('AMA_NO_CONTACT_CANNOT_BE_MESSAGED'), 'Activities', 'top', ToastStyle.INFO);
        }
        await this.emailService.updateEmailActivityParties(emailActivityParties);
      }

      let isProductInactive:boolean = false;
      if(activity.product_id){
        let addedProduct = this.emailService.emailProductSKU.find(p=> p.ID == activity.product_id);
        if(addedProduct && addedProduct.status == "A"){
          await this.emailService.updateEmailActivity({ product_id: activity.product_id }, EmailActionType.PRODUCT);
        }else{
          isProductInactive = true;
        }
      }


      if(activity.template_id && !isProductInactive){
        let selectedTemplate = this.emailService.emailTemplates.find(t => t.indskr_emailtemplateid == activity.template_id);
        if(selectedTemplate && (selectedTemplate.statuscode == 1 || selectedTemplate.statuscode == 548910001)){
          let selectedChannel = selectedTemplate.channelTypes.find(ct => ct.channelType === this.emailService.selectedActivity.channelType);
          let emailBody = (selectedChannel ? selectedChannel.body : selectedTemplate.indskr_body);
          let request = {
            template_id: selectedTemplate.indskr_emailtemplateid,
            subject: selectedTemplate.indskr_email_subject,
            description: emailBody,
            product_id: selectedTemplate.product_id,
            indskr_therapeuticareaid: selectedTemplate.therapeuticareaId
          }
          await this.emailService.updateEmailActivity(request, EmailActionType.TEMPLATE_ADD);
        }
      }

      if(!isProductInactive && newActivity.channelType == ChannelType.EMAIL){
        let emailResources = [];
        if(activity.emailAttachments && activity.emailAttachments.length != 0){
          activity.emailAttachments.forEach(emailRes => {
            let foundRes = this.resourceService.allResources.find(a=> a.ioResourceId == emailRes.indskr_resourceid || a.ioDocumentId == emailRes.indskr_resourceid);
            if(foundRes && foundRes.stateCode != 1){
              emailResources.push(foundRes);
            }
          });
        }
        await this.emailService.detectResourceAddedOrRemoved(emailResources);
      }
      this.openActivityDetails(this.emailService.selectedActivity);
      this.uiService.dismissLoader();
    } catch (error) {
      console.error("Error while cloning email activity"+error);
    }
  }

  public checkCustomScrapCondition(activity): boolean {
    const currentUser = this.authenticationOfflineService.user;
    let flag = true;
    if (activity && activity.type == ActivityType.FollowUp && activity.ownerId != this.authenticationOfflineService.user.systemUserID) {
      flag = false;
    } else if (activity && activity.type == ActivityType.Order) {
      flag = false;
      if(activity.ownerId == this.authenticationOfflineService.user.systemUserID && (activity as OrderActivity).orderStatusString == 'Draft'){
        flag = true;
      }
    } else if (activity && activity.type == ActivityType.SurgeryOrder) {
        const hasVisitorFullAccess   = currentUser?.buSettings['indskr_covisitoraccessonprocedurelog'] === CovisitorAccess.FULL_ACCESS;
        const isCovisitor = activity.coVisitors?.some((coVisitors) => coVisitors.userId === currentUser.systemUserID);
        const isOwner = activity.ownerId === currentUser.xSystemUserID;
        const isCoowner = activity.coOwners?.some((coOwner) => coOwner.userId === currentUser.systemUserID);
        const isCancelledOrCompleted = activity.status === 548910001 || activity.status === 548910005

        flag = !isCancelledOrCompleted && (isOwner || isCoowner || (isCovisitor && hasVisitorFullAccess));
    }else if (activity && activity.type == ActivityType.ProcedureTracker
      && (
        ((activity as ProcedureTrackerActivity).status === 548910001
          && (this.activityService.selectedActivity && this.activityService.selectedActivity.ownerId == this.authenticationOfflineService.user.systemUserID))
        || this.device.isOffline
      )) {
        return false;
    } else if (activity && activity.type == ActivityType.Email && (this.authenticationOfflineService.user.systemUserID != activity.ownerId || activity.status != 1)){
      flag = false;
    } else if (activity && activity.type == ActivityType.Appointment) {
      flag = false;
      if(activity.state == MeetingActivityState.Open) {
        const hasVisitorFullAccess = currentUser?.buSettings['indskr_covisitoraccessonmeeting'] === CovisitorAccess.FULL_ACCESS;
        const isCoVisitor = (activity: AppointmentActivity): boolean => !isEmpty(activity.accompaniedUserList) &&
          activity.accompaniedUserList.some(user => user.id === currentUser.systemUserID);
        if (this.activityService.isActivityOwner(activity) || (hasVisitorFullAccess && isCoVisitor(activity))) {
          flag = true;
        }
      }
    }
     else if (activity && activity.type == ActivityType.StoreCheck &&
      (this.device.isOffline || activity.state == 1 || (activity as StoreCheckActivity).ownerId != this.authenticationOfflineService.user.systemUserID)) {
      flag = false
    } else if (activity && activity.type == ActivityType.PhoneCall && (activity["meetingOwnerId"] != this.authenticationOfflineService.user.systemUserID)){
      flag = false
    }else if (activity && activity.type == ActivityType.CaseIntake && !((activity as CaseActivity)._case_status_value.toLowerCase().includes('open'))){
      flag = false
    }else if(activity && (activity.type == ActivityType.TimeOffRequest || activity.type == ActivityType.TimeOff)
           && (((activity as TimeOffActivity).status == 100000003) || ((activity as TimeOffActivity).status == 100000004))) {
      flag = false;
    }else if (activity && activity.type == ActivityType.SetBooking &&
      (this.device.isOffline ||
      !((activity as SetBookingActivity).indskr_status == SetBookingStatus.DRAFT ||
        (activity as SetBookingActivity).indskr_status == SetBookingStatus.SUBMITTED
      ))){
      flag = false;
    } else if (activity && activity.type === ActivityType.MedicalInquiry) {
      const mi = activity as MedicalInquiry;
      flag =
        mi.isDraft &&
        mi.isActive &&
        !mi.isSubmitted &&
        !this.medicalInquiryService.isParentMeetingClosed(mi) &&
        activity.ownerId === this.authenticationOfflineService.user.systemUserID;
    }
    return flag;
  }

  public checkCustomCloneCondition(activity:Activity):boolean {
    if(!activity) return false;
    let flag:boolean = false;
    switch (activity.type) {
      case ActivityType.Appointment:
        if(activity.isCompleted || (activity as AppointmentActivity).status !== 4){
          flag = true;
        }
        break;
      case ActivityType.PhoneCall:
        if(activity.isCompleted){
          flag = true;
        }
        break;
      case ActivityType.FollowUp:
        if(activity.isCompleted){
          flag = true;
        }
        break;
      case ActivityType.TimeOff:
        if(activity.isCompleted || (activity as TimeOffActivity).status == 100000004){
          flag = true;
        }
        break;
      case ActivityType.Email:
        if(activity.isCompleted || (activity as EmailActivity).emailStatus == 2 || (activity as EmailActivity).emailStatus == 3 || (activity as EmailActivity).emailStatus == 4 || (activity as EmailActivity).emailStatus == 8 || (activity as EmailActivity).emailStatus == 548910000){
          flag = true;
        }
        break;
      case ActivityType.Order:
        if((activity as OrderActivity).status == 548910001 || (activity as OrderActivity).status == 100001){
          flag = true;
        }
        break;
      case ActivityType.CaseIntake:
        const statusValue = (activity as CaseActivity)._case_status_value.toLocaleLowerCase();
        const statusCheck = (!statusValue.includes('open') && !statusValue.includes('pending sync'));
        if(activity.isCompleted || statusCheck) {
          flag = true;
        }
        break;
      case ActivityType.SurgeryOrder:
        flag = (activity as SurgeryOrderActivity).status !== 548910005
        break;
      case ActivityType.ProcedureTracker:
        if(!this.device.isOffline){
          if((activity as ProcedureTrackerActivity).status == 548910001 || (activity as ProcedureTrackerActivity).status == 100001){
            flag = true;
          }
        }
        break;
      case ActivityType.SetBooking:
        if(!this.device.isOffline && (activity as SetBookingActivity).indskr_status !== SetBookingStatus.CANCELLED && (activity as SetBookingActivity).indskr_status !== SetBookingStatus.PENDINGCANCEL && (activity as SetBookingActivity).indskr_status !== SetBookingStatus.CANCELERROR){
          flag=true;
        }
        break;
      case ActivityType.MedicalInquiry: {
        const mi = activity as MedicalInquiry;
        flag =
          mi.isActive &&
          (mi.isDraft || mi.isSubmitted) &&
          activity.ownerId === this.authenticationOfflineService.user.systemUserID;
        break;
      }
    }
    return flag;
  }

  public scrapActivityFromSlideButton(activity:Activity){
    if(!activity) return;

    let foundActivity = activity instanceof AppointmentActivity && activity.indskr_parentcallid
      ? activity
      : this.activityService.getActivityByID(activity.ID);
    if(foundActivity){
      this.events.publish('deleteMeeting',foundActivity);
    }
  }

  private async _handleMoreOptionsPopover(activity,event) {
    let dropdownListDetail: IndDropdownListDetailModel = {
      id: 'activities-pane-more-options-select',
      showClearAllBtn: false,
      data: [],
    };
    if(this.checkCustomCloneCondition(activity)){
      dropdownListDetail.data.push({
        title: this.translate.instant('CLONE'),
        id: 'Clone',
        isSelected: false,
      })
    }

    if(!activity.isCompleted && this.checkCustomScrapCondition(activity)){
      let title =  this.translate.instant('SCRAP');

      if (this.authenticationOfflineService.user.buSettings &&
        ((this.authenticationOfflineService.user.buSettings['indskr_cancelprocedurelogwithreason'] &&
          activity instanceof SurgeryOrderActivity) ||
          (this.authenticationOfflineService.user.buSettings['indskr_cancelmeetingwithreason'] &&
            activity instanceof AppointmentActivity))
      ) {
        title = this.translate.instant('DELETE_OR_CANCEL_PROCEDURE_LOG_HEADER')
      }

      dropdownListDetail.data.push({
        title,
        id: 'Scrap',
        isSelected: false,
      })
    }

    let target = {
      top: event.target.getBoundingClientRect().top,
      bottom: event.target.getBoundingClientRect().bottom,
      height: event.target.getBoundingClientRect().height,
      left: event.target.getBoundingClientRect().left,
      right: event.target.getBoundingClientRect().right,
      width: event.target.getBoundingClientRect().width,
      x: event.target.getBoundingClientRect().x,
      y: event.target.getBoundingClientRect().y,
    };
    let ev:any = {
      target: {
         getBoundingClientRect: () => {
            return target;
         }
      }
   };
    let moreOptionsPopover = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: { viewData: dropdownListDetail },
      cssClass: 'dropdown-list-view',
      event: ev,
    });
    moreOptionsPopover.onDidDismiss().then(async (data: any) => {
      if (data.data) data = data.data;
      if (data && data.selectedItems && data.selectedItems.length == 1) {
        if (data.selectedItems[0].id == 'Clone') {
          this.cloneActivity(activity);
        } else if (data.selectedItems[0].id == 'Scrap') {
          this.scrapActivityFromSlideButton(activity);
        }
      }
    })
    moreOptionsPopover.present();
  }

  private async cloneProcedureTracker(activity: ProcedureTrackerActivity) {
    try {
      const currentTime = new Date().getTime();
      const isWeeklyFlag = ('Weekly' === this.authenticationOfflineService.user.procedureLogDuration);
      const start = this.dateTimeFormatService.toISOString(Utility.getRoundedDownTime(new Date()));
      const end = this.dateTimeFormatService.toISOString(this.dateTimeFormatService.addMinutesToDate(start, 30));
      let startOfWeek, endOfWeek;
      let procedureTrackersPayLoad = [];

      if (isWeeklyFlag) {
        startOfWeek = this.dateTimeFormatService.getStartOfWeek(new Date(start));
        endOfWeek = this.dateTimeFormatService.getEndOfWeek(new Date(start));
        const firstDay = this.dateTimeFormatService.formatDate(this.dateTimeFormatService.getStartOfWeek(new Date(start)), 'MMM DD, YYYY');
        const lastDay = this.dateTimeFormatService.formatDate(this.dateTimeFormatService.getEndOfWeek(new Date(start)), 'MMM DD, YYYY');
        this.notificationService.notify(this.translate.instant('PROCEDURE_LOG_FOR_WEEK', { startDate: firstDay, endDate: lastDay }), 'New Activity', 'top', ToastStyle.INFO);
      }

      if (activity.procedureTrackers.length > 0) {
        await this.activityDataService.updateActivityDetails(activity);
        procedureTrackersPayLoad = activity.procedureTrackers.map((procedureTracker) => {
          return ({
            ...procedureTracker,
             trackerContacts: procedureTracker.trackerContacts.map((trackerContact) => ({ ...trackerContact, id: trackerContact.ID }))
          })
        })
      }

      let payload: any = {
        salesorderid: 'offline_proceduretracker_' + currentTime,
        indskr_externalid: 'offline_proceduretracker_' + currentTime,
        indskr_ordertype: 548910002,
        ordernumber: 'Surgery Order',
        name: 'Bulk Procedure Log',
        pendingPushToDynamics: true,
        statuscode: 1,
        statecode: 0,
        activitytypecode: 'ProcedureTracker',
        createdon: currentTime,
        modifiedon: currentTime + '',
        scheduledstart: (isWeeklyFlag) ? startOfWeek : new Date(start).getTime(),
        scheduledend: (isWeeklyFlag) ? endOfWeek : new Date(end).getTime(),
        divisionName: this.authenticationOfflineService.user.businessUnitName,
        divisionId: this.authenticationOfflineService.user.xBusinessUnitId,
        procedureTrackers: procedureTrackersPayLoad
      }

      let newProcedureTracker = new ProcedureTrackerActivity(payload);
      if (isWeeklyFlag) {
        newProcedureTracker.scheduledEnd = endOfWeek;
      }

      newProcedureTracker.statusString = 'Draft';
      newProcedureTracker.modifiedby = newProcedureTracker.ownerId = this.authenticationOfflineService.user.systemUserID;
      newProcedureTracker.modifiedByName = newProcedureTracker.ownerNameString = this.authenticationOfflineService.user.displayName;
      newProcedureTracker.ownerNameString = this.authenticationOfflineService.user.displayName;

      const procedureLogAction = {
        onDynamics: !this.device.isOffline,
        onLocalCopy: true,
        onLocalDatabase: true
      }

      this.uiService.displayLoader();
      await this.procedureTrackerActivityDataService.createOrderActivity(procedureLogAction, [newProcedureTracker], currentTime, false).then(async (succ) => {
        await this.activityDataService.updateActivityDetails(newProcedureTracker);
        this.activityService.selectedActivity = newProcedureTracker;
        this.trackingService.tracking('AgendanewProcedureTracker', TrackingEventNames.PROCEDURE_TRACKER);
        this.navService.setChildNavRoot(PageName.ProcedureTrackerDetailsComponent, PageName.ProcedureTrackerDetailsComponent, PageName.GoAppActivitiesPageComponent, { from: 'AgendaView', activity: newProcedureTracker });
        this.uiService.activeView = 'ActivitiesPageRightPaneNav';
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.activityService.selectedActivityAtHome = this.activityService.selectedActivity;
        this.uiService.dismissLoader();
        this.activityService.finalizeAgendaRefresh();
      }).catch(err => {
      });
    } catch {

    }
  }

  private async _handleActTabActivityFilter(){
    let options;
    let selectedDateFromFilter = {
      endDate: "",
      startDate: "",
    };
    let selectedFilterData = [];
    if(this.activityService.multiOptionActivityFilter ){
      selectedFilterData = this.activityService.multiOptionActivityFilter;
    }
    const filterMenuModal = await this.modalCtrl.create({
      component: IndFilterMenuComponent,
      componentProps: {
        viewData: {
          data: options,
          isMultipleSelectionEnabled: true,
          title: this.translate.instant('FILTERS'),
          isSearchEnabled: true,
          isReadOnly: false,
          selectedDate: selectedDateFromFilter
        },
        selectedFilter: selectedFilterData,
        from: PageName.GoAppActivitiesPageComponent,
        subFrom: ContactsModel.ACTIVITIES_TAB,
      },
      backdropDismiss: false
    });
    filterMenuModal.present();
    filterMenuModal.onDidDismiss().then(async (obj: any) => {
      if(obj && obj.data && obj.data.isDone){

        if(obj.data.selectedItems.length == 0){
          this.authenticationOfflineService.impersonatedUser = undefined;
          this.activityService.agendaTeamViewActivities = [];
          this.activityService.multiOptionActivityFilter = [];
          this.events.publish('filterActivitiesDataForSelectedUser',ActivityType.AllActivity);
        }else if( obj.data.selectedItems.some(a=> (a.categoryPath == "Users" && a.value != this.authenticationOfflineService.user.systemUserID)) ){
          this.authenticationOfflineService.impersonatedUser = undefined;
          this.activityService.agendaTeamViewActivities = [];
          this.activityService.multiOptionActivityFilter = obj.data.selectedItems;
          this.events.publish('filterActivitiesDataForSelectedUser','MultipleOptionFilter');
        }else if( obj.data.selectedItems.some(a=> a.categoryPath == "Activity_Type" && a.value == ActivityType.AllActivity) ){
          this.authenticationOfflineService.impersonatedUser = undefined;
          this.activityService.agendaTeamViewActivities = [];
          this.activityService.multiOptionActivityFilter = [];
          this.events.publish('filterActivitiesDataForSelectedUser',ActivityType.AllActivity);
        }else {
          this.authenticationOfflineService.impersonatedUser = undefined;
          this.activityService.agendaTeamViewActivities = [];
          this.activityService.multiOptionActivityFilter = obj.data.selectedItems;
          this.events.publish('filterActivitiesDataForSelectedUser','MultipleOptionFilter');
        }
      }
      this.agendaFooterService.initButtons(AgendaFooterView.Act);
    });
  }

  async syncData() {
    let flag = await this.setBookingDataService.checkSetBookingDiscardConfirmationRequired().catch(err => { });
    if (!flag) return;
    this.activityService.deltaSyncData();
  }

  getRoundedTime(mDate) {
    if(this.authenticationOfflineService.user.buSettings["indskr_meetingstarttimerounding"] === false) return mDate
    let d = mDate;
    if (d.getMinutes() < 30) {
      d.setMinutes(30);
      d.setSeconds(0);
      d.setMilliseconds(0);
      return d;
    } else {
      d.setMinutes(0);
      d.setHours(d.getHours() + 1);
      d.setSeconds(0);
      d.setMilliseconds(0);
      return d;
    }
  }

  private _getLocalDateKey(date: Date): string {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0')
    ].join('-'); // "YYYY-MM-DD" 
  }
}

